import React, { useState, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import white from "../../../Assets/Images/whitebg.jpg";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import CircularProgress from "@mui/material/CircularProgress";
import { url, url3 } from "../../../Config";
import RefreshIcon from "@mui/icons-material/Refresh";
import { decryptParams } from '../encrypt_url';
import { useLocation } from 'react-router-dom';
import {encryptParams} from "../encrypt_url";
import "./loader.css";



export default function PPL() {
  const location = useLocation();
  const pathname = location.pathname;
  const encryptedParams = pathname.substring('/Ratings/addTask/PPL/'.length);
  // Decrypt the parameters
  const { client_id, og_rating_id } = decryptParams(encryptedParams);
  const isadmin = localStorage.getItem('admin');
  const Navigate = useNavigate();
  const [data, setdata] = useState({});
  const [ppldata, setppldata] = useState(null);
  const [alredyGenenatedPpl, setalredyGenenatedPpl] = useState([]);
  const [alredyGenenatednl, setalredyGenenatednl] = useState([]);
  const [alredyGenenatedRc, setalredyGenenatedRc] = useState([]);
  const [getPpls, setgetPpls] = useState([]);
  const [lastRC, setlastRC] = useState([]);
  const [alertopen, setalertopen] = useState(false);
  const [alertopene, setalertOpene] = useState(false);
  const [alertTypee, setalertTypee] = useState();
  const [AlertMessagee, setalertmessagee] = useState();
  const [alertopen2, setalertopen2] = useState(false);
  const [AlertMessage, setAlertMessage] = useState(null);
  const [alertopen3, setalertopen3] = useState(false);
  const [AlertMessage3, setAlertMessage3] = useState(null);
  const [alertType3, setalertType3] = useState("error");
  const [alertopen4, setalertopen4] = useState(false);
  const [AlertMessage4, setAlertMessage4] = useState(null);
  const [alertType4, setalertType4] = useState("error");
  const [alertopen5, setalertopen5] = useState(false);
  const [AlertMessage5, setAlertMessage5] = useState(null);
  const [alertType5, setalertType5] = useState("error");
  const [alertopen6, setalertopen6] = useState(false);
  const [AlertMessage6, setAlertMessage6] = useState(null);
  const [alertType6, setalertType6] = useState("error");
  const [alertopen7, setalertopen7] = useState(false);
  const [AlertMessage7, setAlertMessage7] = useState(null);
  const [alertType7, setalertType7] = useState("error");
  const [alertType, setalertType] = useState("error");
  const id = localStorage.getItem("userID")
  const [financial_file, setfinancial_file] = useState(null);
  const [disclosure_file, setdisclosure_file] = useState(null);
  const [bool, setbool] = useState(false);
  const [instrument, setinstrument] = useState("Select Instrument Type");
  const [amount, setamount] = useState(null);
  const [issuance, setissuance] = useState(null);
  const [tenor, settenor] = useState(null);
  const [redemption, setredemption] = useState(null);
  const [instrumenttype, setinstrumenttype] = useState([]);
  const [opinionsdata, setopinionsdata] = useState(null);
  const [RRandKrd, setRRandKrd] = useState(0);
  const [changeopinion, setchangeopinion] = useState(false);
  const [allppl, setallppl] = useState([]);
  const [clientid, setclientid] = useState(null);
  const [pplcount, setpplcount] = useState(null);
  const [opinion, setopinion] = useState([]);
  const processpage = "PPL";
  const [checktask, setchecktask] = useState([]);
  const [reopen, setreopen] = useState(null);
  const [commentary, setcommentary] = useState("");
  const [asset_manager, setasset_manager] = useState("");
  const [incorporation, setincorporation] = useState("");
  const [conventional_funds, setconventional_funds] = useState("");
  const [shariah_compliant_funds, setshariah_compliant_funds] = useState("");
  const [pension_schemes, setpension_schemes] = useState("");
  const [ceo, setceo] = useState("");
  const [cio, setcio] = useState("");
  const [aums, setaums] = useState("");
  const [aumc_rating, setaumc_rating] = useState("");
  const [prompt, setprompt] = useState("");
  const [loading, setLoading] = useState(false);
  const [count, setcount] = useState("loading");
  const [bool1, setbool1] = useState(false);
  




  function DateFormat(params) {
    if (params == null) {
      return "-";
    } else {
      const date = new Date(params);
      const yyyy = date.getFullYear();
      const yy = yyyy.toString();
      const y = yy.slice(2, 4);
      let mm = date.toLocaleString("default", { month: "short" });
      let dd = date.getDate();
      if (dd < 10) dd = "0" + dd;
      return dd + "-" + mm + "-" + y;
    }
  }

  useEffect(()=>{
    if(id != "19" && id !== "42" && id !== "12"){
      const func = async ()=>{
        const res = await axios.get(`${url}/api/agreedinProcess/${id}`);
        const resp = res.data;
        const arr = [];
        for(let i in resp){
          if(resp[i].user_id == id || resp[i].lead_rc_id == id || resp[i].user_id1 == id){
            arr.push(resp[i]);
          }
        }
        setopinion(arr);
      }
      func();
    }
    else{
      const func = async ()=>{
        const resp2 = await axios.get(
          `${url}/api/myinprocess/${id}`
        );
        const data2 = resp2.data;
        const arr2 = [];
        for(let i in data2){
          if(data2[i].user_id == id || data2[i].lead_rc_id == id || data2[i].user_id1 == id || id == "42" || id == "12"){
              arr2.push(data2[i]);
          }
        } 
        setopinion(arr2);
      }

      func();
    }

  },[]);
  
  
  // const [financial_file, setfinancial_file] = useState(null);


  useEffect(() => {
    const func = async () => {
      const resp = await axios.get(`${url}/api/addTask/FC/${client_id}/${og_rating_id}`);
      const res = resp.data;
      const response = res[0];
      // const res2 = resp2.data;
      if(response.edit_module_tasks !== null){
        let arr = response.edit_module_tasks.split(',');
        setchecktask(arr);

        }
      else{
        setchecktask([]);
      }
      
      setreopen(response.reopen);
      setdata(res[0]);
      const instrumenttype = await axios.get(`${url}/api/instrument`);
      const instrumenttyperesp = instrumenttype.data.data;
      setinstrumenttype(instrumenttyperesp);
      const opiniondata = await axios.get(`${url}/api/getAddDetailsData/${client_id}`);
      const opinion = opiniondata.data.data[0];
      setopinionsdata(opinion);
      if(opinion.instrument_type_id !== null && opinion.instrument_type_id !== 0 && opinion.instrument_type_id !== "0"){
        setinstrument(opinion.instrument_type_id);
      }
      setamount(opinion.instrument_amount);
      setissuance(opinion.instrument_issuedate);
      settenor(opinion.instrument_tenure);
      setredemption(opinion.termination_date);
      
    };
    func();
  }, [changeopinion]);

  useEffect(()=>{
    setppldata(null);
    const func = async ()=>{
      const getpplapi = await axios.get(`${url}/api/ppl_data/${id}/${client_id}/${og_rating_id}`)
      const getppl = getpplapi.data;
      setppldata(getppl);
      setallppl(getppl.allPPl);
      setpplcount(getppl.ppl_count);
      setalredyGenenatedPpl(getppl.alredyGenenatedPpl);
      setalredyGenenatednl(getppl.alredyGenenatednl);
      setalredyGenenatedRc(getppl.alredyGenenatedRc);
      setgetPpls(getppl.getPpls);
      setlastRC(getppl.lastRC);
      setclientid(getppl.client_id);
      setcommentary(getppl.commentary);
      const checkRRandKRD = await axios.get(`${url}/api/checkRRandKRD/${client_id}/${og_rating_id}/${getppl.opDetails[0].rating_scale_id}`)
      setRRandKrd(checkRRandKRD.data.RRandKrd);

      if(getppl.assetmanager  !== null){
        let asset = getppl.assetmanager;
        setasset_manager(asset.asset_manager);
        setincorporation(asset.year_of_incorporation);
        setconventional_funds(asset.conventional_funds);
        setshariah_compliant_funds(asset.shariah_compliant_funds);
        setpension_schemes(asset.pension_schemes);
        setceo(asset.ceo);
        setcio(asset.cio);
        setaums(asset.aums);
        setaumc_rating(asset.aumc_rating);

      }

    }
    func();
  },[bool, changeopinion])

  const uploadfinancials = async (event)=>{
    setalertopen4(false);
    event.preventDefault();
    const fileData = new FormData();
    console.log(financial_file);
    fileData.append("filename", financial_file);
    fileData.append("stage", "Financials");
    fileData.append("recordId", og_rating_id);
    const res = await axios.post(`${url}/api/storepplfiles`,
    fileData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  )
  if(res.data.status == true && res.data.message == "Financials added successfully"){
    setalertType4("success");
    setAlertMessage4("Financials Uploaded Successfully");
    setalertopen4(true);
  }
  else{
    setalertType4("error");
    setAlertMessage4(res.data.message);
    setalertopen4(true);
  }

  }

  const uploadDisclosure = async (event)=>{
    event.preventDefault();
    setalertopen5(false);
    const fileData = new FormData();
    fileData.append("filename", disclosure_file);
    fileData.append("stage", "Disclosure");
    fileData.append("recordId", og_rating_id);
    const res = await axios.post(`${url}/api/storepplfiles`,
    fileData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  )

  if(res.data.status == true && res.data.message == "Disclosure added successfully"){
    setalertType5("success");
    setAlertMessage5("Disclosure Uploaded Successfully");
    setalertopen5(true);
  }
  else{
    setalertType5("error");
    setAlertMessage5(res.data.message);
    setalertopen5(true);
  }

  }

  const cancelReview = async ()=>{
    const res = await axios.post(`${url}/api/cancelReview`,{
      "recId" : ppldata.lastRecord['id']
    });
    if(res.data.status == true){
      setalertType("success");
      setAlertMessage(res.data.message);
      setalertopen(true);
      setbool(!bool);
    }
    else{
      setalertType("error");
      setAlertMessage("Some Error occure while Processing your request");
      setalertopen(true);
    }
  }

  const addDetail = async ()=>{
    if(instrument == "Select Instrument Type"){
      setinstrument(null);
    }
    const res = await axios.post(`${url}/api/instrumentChangesFormApi`,{
      "opinionId": client_id,
      "instrument": instrument,
      "amount": amount,
      "issuance": issuance,
      "tenor": tenor,
      "redemption":  redemption
    });

    if(res.data.status == true){
        setalertType3("success");
        setAlertMessage3("Successfully Updated");
        setalertopen3(true);
    }
    else{
      setalertType3("error");
      setAlertMessage3("Some Error occure while Processing your request");
      setalertopen3(true);
    }
  }

  const generateReport = async()=>{
    try {
      document.getElementById("gn").hidden = true;
      document.getElementById("generateprogress").hidden = false;
      const res = await axios.get(`${url3}/api/generateReport/${client_id}/${og_rating_id}/ppl`);
      console.log(res, "response");
      if(res.status == 200){
        document.getElementById("gn").hidden = false;
        document.getElementById("generateprogress").hidden = true;
        if((data.rating_scales_title == "Entity" && data.initiation_date >= "2024-10-28") ||  (data.rating_scales_title == "Debt Instrument" && data.initiation_date >= "2025-06-27") || (data.rating_scales_title == "IFS" && data.initiation_date >= "2025-07-01") || (data.rating_scales_title == "Asset Manager" && data.initiation_date >= "2025-08-06") || (data.rating_scales_title == "Investment Advisor Rating " && data.initiation_date >= "2025-08-06") || (data.rating_scales_title == "Broker Management" && data.initiation_date >= "2025-08-06") || (data.rating_scales_title == "Stability Rating")){
          window.open(`${url}/rating-report/${og_rating_id}`, '_blank');
        }
        else{
          window.open(`${url3}/api/generateReport/${client_id}/${og_rating_id}/ppl`, '_blank');
        }
      }
    } catch (error) {
      document.getElementById("gn").hidden = false;
      document.getElementById("generateprogress").hidden = true;
      setalertType("error");
      
      if(error.response !== null){
        setAlertMessage(error.response.data.message);
      }
      setalertopen(true);
    }
  }

  const preventKeyboardInput = (e) => {
    e.preventDefault();
  };

  const AddCommentary = async ()=>{

    const res = await axios.post(`${url}/api/add-commentary`,{
      'record_id': og_rating_id,
      'commentary': commentary

    })

    const resp = res.data;
    if(resp.status == true){
        setalertType6("success");
        setAlertMessage6("Successfully Updated");
        setalertopen6(true);
    }
    else{
      setalertType6("error");
      setAlertMessage6("Some Error occure while Processing your request");
      setalertopen6(true);
    }

  }

  const AddAssetManager= async ()=>{



  const res = await axios.post(`${url}/api/add_asset_manager`,{
      'client_id': clientid,
      'asset_manager': asset_manager,
      'year_of_incorporation': incorporation,
      'conventional_funds': conventional_funds,
      'shariah_compliant_funds': shariah_compliant_funds,
      'pension_schemes': pension_schemes,
      'ceo': ceo,
      'cio': cio,
      'aums': aums,
      'aumc_rating': aumc_rating


    })

    const resp = res.data;
    if(resp.status == true){
        setalertType7("success");
        setAlertMessage7("Successfully Updated");
        setalertopen7(true);
    }
    else{
      setalertType7("error");
      setAlertMessage7("Some Error occure while Processing your request");
      setalertopen7(true);
    }
  }

  const submitgraph = async (event)=>{
        event.preventDefault();
        setalertOpene(false);

        document.getElementById('submite').innerHTML = 'Loading...';
        document.getElementById('submite').disabled = true;

        const fileData = new FormData();
        const file = document.getElementById(`graphfile`).files[0];

        fileData.append("record_id", og_rating_id);
        fileData.append("opinion_id", client_id);
        fileData.append("file", file);
        
        const res = await axios.post(
          `${url3}/api/stability_graphs_upload`,
          fileData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        console.log(res, "response")
        
        const resp = res.data;
        
        if(resp.status == true){
          setalertOpene(true);
          setalertTypee("success");
          setalertmessagee('File Uploaded');
          document.getElementById('submite').innerHTML = 'Save';
          document.getElementById('submite').disabled = false;
        }

        else{
          setalertOpene(true);
          setalertTypee("error");
          setalertmessagee('Error Occure');
          document.getElementById('submite').innerHTML = 'Save';
          document.getElementById('submite').disabled = false;
        }
  }

  useEffect(()=>{
              const func = async ()=>{
        
                const res = await axios.get(`${url}/api/rr_ai_count2/${og_rating_id}`);
                const resp = res.data;
                setcount(resp);
        
              }
              func()
    },[bool1])

  const generateRRandKRD = async (event) => {
        // event.preventDefault();
  
        // document.getElementById("promptclose").click();
        setLoading(true);
        const res = await axios.post(`https://159.223.54.181/api/generate-rationale-content/${og_rating_id}`,{
          customPrompt : "no",
          user_id: Number(id)
        })
       
        if(res.status == 200){
          // setprompt("");
          setbool1(!bool1);
          setLoading(false);
          setalertType("success");
          setalertopen(true);
          setAlertMessage(res.data);
        }
        else{
          setLoading(false);
          setalertType("error");
          setalertopen(true);
          setAlertMessage("Some Error Occure while Processing your request");
        }
    }

  const currentDate = ()=>{

      const date = new Date();

      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); // months are 0-based
      const year = date.getFullYear();

      const formattedDate = `${day}-${month}-${year}`;
      return formattedDate;
  }

  return (
    <div style={{height: "90vh"}}>
      <div
        className="fs-3 fw-bold text-center mt-2"
        style={{ color: "#000078", fontFamily: "Kalinga" }}
      >
        PPL
      </div>
      <div
        className="card m-2 shadow"
        style={{
          backgroundColor: "#e0e0e0",
          backgroundImage: `url(${white})`,
          backgroundSize: "cover",
        }}
      >
        <div className="row p-2">
          <div className="col-lg-6 col-md-6 col-sm-12 mb-1">
            <div className="row">
              <div className="col-lg-4 col-md-4 col-sm-3 col-12 mt-1">
                <label
                  className="ms-lg-5 ms-md-5 ms-1 fw-bold fs-6"
                  style={{ color: "#000078", fontFamily: "Kalinga", fontSize:"0.5vw" }}
                >
                  CRO
                </label>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                <input
                  className="form-control"
                  disabled
                  type="text"
                  defaultValue={data && data.lead_name}
                ></input>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12 mb-1">
            <div className="row">
              <div className="col-lg-4 col-md-4 col-sm-3 col-12 mt-1">
                <label
                  className="ms-lg-5 ms-md-5 ms-1 fw-bold fs-6"
                  style={{ color: "#000078", fontFamily: "Kalinga", fontSize:"0.5vw"  }}
                >
                  Team Lead
                </label>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 col-12 ms-lg-3 ms-md-3">
                <input
                  className="form-control"
                  disabled
                  type="text"
                  defaultValue={data && data.manager_name}
                >
                </input>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12 mb-1">
            <div className="row">
              <div className="col-lg-4 col-md-4 col-sm-3 col-12 mt-1">
                <label
                  className="ms-lg-5 ms-md-5 ms-1 fw-bold fs-6"
                  style={{ color: "#000078", fontFamily: "Kalinga", fontSize:"0.5vw"  }}
                >
                  {" "}
                  Analyst{" "}
                </label>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                <input
                  className="form-control"
                  disabled
                  type="text"
                  defaultValue={data && data.username}
                ></input>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12 mb-1">
            <div className="row">
              <div className="col-lg-4 col-md-4 col-sm-3 col-12 mt-1">
                <label
                  className="ms-lg-5 ms-md-5 ms-1 fw-bold fs-6"
                  style={{ color: "#000078", fontFamily: "Kalinga", fontSize:"0.5vw"  }}
                >
                  {" "}
                  Opinion{" "}
                </label>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 col-12 ms-lg-3 ms-md-3">
                <select className="form-select" value={`${client_id},${og_rating_id}`} onChange={(e)=>{
                  const val = e.target.value;
                  const arr = val.split(",");
                  const client_id = arr[0];
                  const og_rating_id = arr[1];
                  const encryptedParams = encryptParams({client_id, og_rating_id});
                  Navigate(`/Ratings/addTask/PPL/${encryptedParams}`);
                  setchangeopinion(!changeopinion);
                }}>
                  {
                    opinion.map((value, index)=>{
                      return(
                        <option value={`${value.Id},${value.record_id}`}>{value.Entity}</option>
                      )
                    })
                  }
                </select>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12 mb-1">
            <div className="row">
              <div className="col-lg-4 col-md-4 col-sm-3 col-12 mt-1">
                <label
                  className="ms-lg-5 ms-md-5 ms-1 fw-bold fs-6"
                  style={{ color: "#000078", fontFamily: "Kalinga", fontSize:"0.5vw"  }}
                >
                  {" "}
                  Rating Update Type{" "}
                </label>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 col-12">
              <input
                  className="form-control"
                  disabled
                  type="text"
                  defaultValue={data && data.ratingUpdateType_title}
                ></input>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12 mb-1">
            <div className="row">
            <div className="col-lg-4 col-md-4 col-sm-3 col-12 mt-1">
                <label
                  className="ms-lg-5 ms-md-5 ms-1 fw-bold fs-6"
                  style={{ color: "#000078", fontFamily: "Kalinga", fontSize:"0.5vw"  }}
                >
                  Process
                </label>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 col-12 ms-lg-3 ms-md-3">
              <select className="form-select" defaultValue={processpage} onChange={(e)=>{
                const encryptedParams = encryptParams({client_id, og_rating_id})
                Navigate(`/Ratings/addTask/${e.target.value}/${encryptedParams}`);
              }}>
                <option value={"Information"}>Information</option>
                <option value={"Assessment"}>Assessment</option>
                <option value={"SiteVisit"}>Site Visit</option>
                <option value={"MM"}>MM</option>
                <option value={"RC"}>RC</option>
                <option value={"PPL"}>PPL</option>
                <option value={"NL"}>NL</option>
                <option value={"RR"}>RR</option>
                <option value={"RED"}>RED</option>
              </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isadmin == 'true' &&
      <div className="text-center">
            <b>Record id:</b> {og_rating_id} <b>Opinion id:</b> {client_id}
      </div>}
      <div className="mx-auto mt-2 mb-2" style={{width: "fit-content"}} onClick={()=>{setbool(!bool);}}>
        <i class="fa fa-refresh fa-2x" aria-hidden="true"></i>
      </div>
      {(reopen == 'Open' && checktask.includes('NL') == true) ?
      <div className="card m-2 shadow p-2">
        
        {ppldata !== null ? alredyGenenatedRc.length == 0 && <Box className="mx-auto" sx={{ width: "98%" }}>
                    <Collapse in={true}>
                      <Alert
                        severity={'error'}
                        sx={{ mb: 2 }}
                      >
                        {'Please generate RC to enable RR & KRD'}
                      </Alert>
                    </Collapse>
          </Box> : null}
        {ppldata !== null ? ppldata.financialsFile[0].rc_upload_date == null && <Box className="mx-auto" sx={{ width: "98%" }}>
                    <Collapse in={true}>
                      <Alert
                        severity={'error'}
                        sx={{ mb: 2 }}
                      >
                        {'RC approval is required for PPL'}
                      </Alert>
                    </Collapse>
          </Box> : null}
          <Box className="mx-auto mt-1 mb-1" sx={{ width: "98%" }}>
                <Collapse in={alertopen}>
                    <Alert
                        severity={alertType}
                        action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setalertopen(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        sx={{ mb: 2 }}
                      >
                        {AlertMessage}
                    </Alert>
                </Collapse>
          </Box>
          {isadmin == "true" ? <button type="button" className="ms-1 btn btn-primary" onClick={()=>{window.open(`https://209.97.168.200/pacrawizpackv3/public/regenerate-rating-report/${og_rating_id}`, '_blank')}}>Hard Generate RR</button> : null}
        {ppldata !== null ? 
        <div className="d-flex">

          {
            ppldata !== null ?
            ppldata.lastRecord['pacra_outlook'] == ppldata.secondLastRecord['pacra_outlook'] &&
            ppldata.lastRecord['pacra_five_yr'] == ppldata.secondLastRecord['pacra_five_yr'] &&
            ppldata.lastRecord['pacra_lterm'] == ppldata.secondLastRecord['pacra_lterm'] &&
            (ppldata.lastRecord['pacra_sterm'] == ppldata.secondLastRecord['pacra_sterm'] ||
            ppldata.secondLastRecord['pacra_sterm'] == '5') ?
            
            ppldata.secondLastRW !== "unset" && ppldata.lastRecord.review_cancelled != 1 && ppldata.lastRW == ppldata.secondLastRW ?
            <>
              {
                alredyGenenatedRc.length > 1 ? getPpls.length == 2 ?
                <> { (Number(data.rating_update_type) != 6 && Number(data.rating_update_type) != 4) || (ppldata.review == 0) ? <div className="me-1 mb-1" style={{width: "fit-content"}}><button className="btn btn-primary " type="button" onClick={()=>{window.open(`/Ratings/edit_ppl/${client_id}/${og_rating_id}`, '_blank')}}> Post Appeal PPL </button> </div> : null }</> :
                <>{ (Number(data.rating_update_type) != 6 && Number(data.rating_update_type) != 4) || (ppldata.review == 0) ? <div className="me-1 mb-1" style={{width: "fit-content"}}><button className="btn btn-primary " type="button" onClick={()=>{window.open(`/Ratings/closer_internally/${ppldata.lastRecord['client_id']}/${ppldata.lastRecord['id']}`, '_blank')}}> Close Internally </button> </div> : null} </> : null
              }
              {
                alredyGenenatedRc.length <= 1 && <> {(Number(data.rating_update_type) != 6 && Number(data.rating_update_type) != 4) || (ppldata.review == 0) ? <div className="me-1 mb-1" style={{width: "fit-content"}}> <button className="btn btn-primary " type="button" onClick={()=>{window.open(`/Ratings/closer_internally/${ppldata.lastRecord['client_id']}/${ppldata.lastRecord['id']}`, '_blank')}}> Close Internally </button> </div> : null}</>
              }
              {
                ppldata.lastRecord.reviewId=='' || ppldata.lastRecord.reviewId== null ? <> { (Number(data.rating_update_type) != 6 && Number(data.rating_update_type) != 4) || (ppldata.review == 0) ? <div className="me-1 mb-1" style={{width: "fit-content"}}> <button className="btn btn-primary " type="button" onClick={()=>{cancelReview()}}> Dissemination </button> </div> : null}</> : null
              }
            </>
            :
            <>
              {
                alredyGenenatedPpl.length == 0 ?
                ppldata.financialsFile[0].rc_upload_date != null ?
                <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" onClick={()=>{window.open(`/Ratings/generate_ppl/${client_id}/${og_rating_id}`, '_blank')}}> Generate PPL </button> 
                </div> : null : null
              }
              {
                alredyGenenatedPpl.length > 0 ?
                alredyGenenatedPpl[0].second_approve !== 'Approved' ?
                <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" onClick={()=>{window.open(`/Ratings/edit_ppl/${client_id}/${og_rating_id}`, '_blank')}}> Edit PPL </button> 
                </div> : 
                alredyGenenatednl.length == 0 ?
                <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary" type="button" onClick={()=>{window.open(`/Ratings/edit_ppl/${client_id}/${og_rating_id}`, '_blank')}}> PPL </button> 
                </div> :
                <> 
                {
                alredyGenenatednl.length > 0 ?
                alredyGenenatednl[0].second_approve != "Approved" ?
                <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" onClick={()=>{window.open(`/Ratings/edit_ppl/${client_id}/${og_rating_id}`, '_blank')}}> PPL </button> 
                </div> :
                <>
                {
                  pplcount > 1 ?
                  allppl.map((value, index)=>{
                    return(
                      <div className="me-1 mb-1" style={{width: "fit-content"}}>
                      <button className="btn btn-primary " type="button" onClick={()=>{
                        window.open(`/Ratings/pplview/${value.id}`);
                      }} >View PPL ({DateFormat(value.date)})</button>
                     </div>
                    )
                  }) :
                  <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" onClick={()=>{
                    window.open(`/Ratings/pplview/${alredyGenenatedPpl[0].id}`);
                  }} >View PPL</button>
                </div> 
                }
                </> : null
                }
                </> : null
              }
              {/* {
                alredyGenenatedPpl.length > 0 ?
                alredyGenenatedPpl[0].second_approve == 'Approved' && alredyGenenatednl.length == 0 ?
                <>
                {
                  pplcount > 1 ?
                  allppl.map((value, index)=>{
                    return(
                      <div className="me-1 mb-1" style={{width: "fit-content"}}>
                      <button className="btn btn-primary " type="button" onClick={()=>{
                        window.open(`/Ratings/pplview/${value.id}`);
                      }} >View PPL ({DateFormat(value.date)})</button>
                     </div>
                    )
                  }) :
                  <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" onClick={()=>{
                    window.open(`/Ratings/pplview/${alredyGenenatedPpl[0].id}`);
                  }} >View PPL 2</button>
                </div> 
                }
                </>
                : null : null
              } */}

              {
                alredyGenenatednl.length > 0 ?
                alredyGenenatednl[0].second_approve != "Approved" ?
                ppldata.opDetails[0].rating_scale_id == 19 ?
                <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" onClick={()=>{window.open(`/Ratings/bfr/${client_id}/${og_rating_id}`, '_blank')}}> RR & KRD(BFR) </button> 
                </div> :
                ppldata.opDetails[0].rating_scale_id == 28 ?
                <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" onClick={()=>{window.open(`/Ratings/bfr/${client_id}/${og_rating_id}`, '_blank')}}> RR & KRD(SIP) </button> 
                </div> :
                ppldata.opDetails[0].rating_scale_id == 7 ?
                <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" onClick={()=>{window.open(`/Ratings/perf_rank/${client_id}/${og_rating_id}`, '_blank')}}> RR & KRD(Performance Ranking) </button> 
                </div> :
                <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" onClick={()=>{window.open(`/Ratings/rr_krd/${client_id}/${og_rating_id}/add/${ppldata.financialsFile[0].rating_type_id}`, '_blank')}}> RR & KRD </button> 
                  {((isadmin == "true" && data.rating_scales_title == "Entity" && data.segment_id == 2 && (data.ratingUpdateType_title == "Interim" || data.ratingUpdateType_title == "Annual" || data.ratingUpdateType_title == "Surveillance") && data.model_name.includes("Corporate")) || (data.rating_scales_title == "Entity" && data.model_name.includes("Corporate") && data.segment_id == 2 && (data.ratingUpdateType_title == "Interim" || data.ratingUpdateType_title == "Annual" || data.ratingUpdateType_title == "Surveillance") && data.initiation_date >= "2026-07-01")) ?
                    <>{(count == 0 || count  == null ) && <button  className="btn btn-primary ms-1" type="button" onClick={()=>{generateRRandKRD()}}>Generate AI RR & KRD <i class="fa fa-magic" style={{fontSize:  20}}></i> </button>}</> : null}
                </div> : null :
                alredyGenenatedRc.length > 0 ?
                ppldata.opDetails[0].rating_scale_id == 19 ?
                <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" onClick={()=>{window.open(`/Ratings/bfr/${client_id}/${og_rating_id}`, '_blank')}}> RR & KRD(BFR) </button> 
                </div> :
                ppldata.opDetails[0].rating_scale_id == 28 ?
                <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" onClick={()=>{window.open(`/Ratings/bfr/${client_id}/${og_rating_id}`, '_blank')}}> RR & KRD(SIP) </button> 
                </div> :
                ppldata.opDetails[0].rating_scale_id== 7 ?
                <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" onClick={()=>{window.open(`/Ratings/perf_rank/${client_id}/${og_rating_id}`, '_blank')}}> RR & KRD(Performance Ranking) </button> 
                </div>:                
                <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" onClick={()=>{window.open(`/Ratings/rr_krd/${client_id}/${og_rating_id}/add/${ppldata.financialsFile[0].rating_type_id}`, '_blank')}}> RR & KRD </button> 
                  {((isadmin == "true" && data.rating_scales_title == "Entity" && data.model_name.includes("Corporate") && data.segment_id == 2 && (data.ratingUpdateType_title == "Interim" || data.ratingUpdateType_title == "Annual" || data.ratingUpdateType_title == "Surveillance")) || (data.rating_scales_title == "Entity" && data.model_name.includes("Corporate") && data.segment_id == 2 && (data.ratingUpdateType_title == "Interim" || data.ratingUpdateType_title == "Annual" || data.ratingUpdateType_title == "Surveillance") && data.initiation_date >= "2026-07-01")) ? 
                  <>{(count == 0 || count  == null ) && <button  className="btn btn-primary ms-1" type="button" onClick={()=>{generateRRandKRD()}}>Generate AI RR & KRD <i class="fa fa-magic" style={{fontSize:  20}}></i> </button>}</> : null}
                </div> : null
              }

              {
                RRandKrd !== 0 && <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " target="_blank" onClick={()=>{
                    window.open(`${url}/api/draftPr/${og_rating_id}`, '_blank')}
                    }> Draft PR </button> 
                </div>
              }
              {
                alredyGenenatednl.length > 0 ?
                alredyGenenatednl[0].second_approve != "Approved" ? 
                <>
                {ppldata.opDetails[0].rating_scale_id !== 6 && ppldata.opDetails[0].rating_scale_id !== 7 ? <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  {(data.rating_scales_title == "Entity" && data.segment_id == 2 && (data.ratingUpdateType_title == "Interim" || data.ratingUpdateType_title == "Annual" || data.ratingUpdateType_title == "Surveillance") && data.initiation_date >= "2026-07-01" && data.model_name.includes("Corporate")) ? null : <button className="btn btn-primary " type="button" style={{width : "100%"}} data-bs-toggle="modal" data-bs-target="#staticBackdropF">Upload Financials</button>}
                </div> : null}
                {ppldata.opDetails[0].rating_scale_id== 9 ? 
                <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" data-bs-toggle="modal" data-bs-target="#staticBackdropD">Upload Disclosure</button> 
                </div> : null}
                </> : null :
                <>
                {ppldata.opDetails[0].rating_scale_id !== 6 && ppldata.opDetails[0].rating_scale_id !== 7 ? <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  {(data.rating_scales_title == "Entity" && data.segment_id == 2 && (data.ratingUpdateType_title == "Interim" || data.ratingUpdateType_title == "Annual" || data.ratingUpdateType_title == "Surveillance") && data.initiation_date >= "2026-07-01" && data.model_name.includes("Corporate")) ? null : <button className="btn btn-primary " type="button" style={{width : "100%"}} data-bs-toggle="modal" data-bs-target="#staticBackdropF">Upload Financials</button>}
                </div> : null}
                {ppldata.opDetails[0].rating_scale_id== 9 &&
                <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" data-bs-toggle="modal" data-bs-target="#staticBackdropD">Upload Disclosure</button>
                </div>}
                </>
              }
              {
                alredyGenenatednl.length > 0 ? 
                alredyGenenatednl[0].second_approve != "Approved" ?
                <> 
                  { ppldata !== null ?
                    ppldata.opDetails[0].rating_scale_id !== 6 && ppldata.opDetails[0].rating_scale_id !== 7 && ppldata.opDetails[0].pacra_action !== 5
                    && ppldata.opDetails[0].pacra_action !== 6 && ppldata.opDetails[0].pacra_action !== 11 && ppldata.opDetails[0].pacra_action !== 18 &&
                  <div className="me-1 mb-1" style={{width: "fit-content"}}>
                    <button type="button" className="btn btn-primary " onClick={()=>{generateReport()}}> <div id="gn">Generate Report</div> <div id="generateprogress" hidden>Please Wait...</div></button>
                  </div> : null
                    }
                  
                </>
                 : null :
                 <> 
                  { ppldata !== null ?
                    ppldata.opDetails[0].rating_scale_id !== 6 && ppldata.opDetails[0].rating_scale_id !== 7 && ppldata.opDetails[0].pacra_action !== 5
                    && ppldata.opDetails[0].pacra_action !== 6 && ppldata.opDetails[0].pacra_action !== 11 && ppldata.opDetails[0].pacra_action !== 18 &&
                    <div className="me-1 mb-1" style={{width: "fit-content"}}>
                    <button type="button" className="btn btn-primary " onClick={()=>{generateReport()}}> <div id="gn">Generate Report</div> <div id="generateprogress" hidden>Please Wait...</div></button>
                    </div> : null
                  }
                 </>
              }
            </> 
            :
            <>
 
              {
                alredyGenenatednl.length > 0 ?
                alredyGenenatednl[0].second_approve != "Approved" ?
                <>
              {
                  ppldata.opDetails[0].rating_scale_id == 19 ?
                  <div className="me-1 mb-1" style={{width: "fit-content"}}>
                    <button className="btn btn-primary " type="button" onClick={()=>{window.open(`/Ratings/bfr/${client_id}/${og_rating_id}`, '_blank')}}> RR & KRD(BFR) </button> 
                  </div> :
                  ppldata.opDetails[0].rating_scale_id == 28 ?
                  <div className="me-1 mb-1" style={{width: "fit-content"}}>
                    <button className="btn btn-primary " type="button" onClick={()=>{window.open(`/Ratings/bfr/${client_id}/${og_rating_id}`, '_blank')}}> RR & KRD(SIP) </button> 
                  </div> :
                ppldata.opDetails[0].rating_scale_id== 7 ?
                <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" onClick={()=>{window.open(`/Ratings/perf_rank/${client_id}/${og_rating_id}`, '_blank')}}> RR & KRD(Performance Ranking) </button>
                </div> :
                <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" onClick={()=>{window.open(`/Ratings/rr_krd/${client_id}/${og_rating_id}/add/${ppldata.financialsFile[0].rating_type_id}`, '_blank')}}> RR & KRD </button>
                </div>
              }

              { ppldata !== null ? ppldata.financialsFile[0].rc_upload_date != null ?
                <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" onClick={()=>{window.open(`/Ratings/edit_ppl/${client_id}/${og_rating_id}`, '_blank')}}> PPL </button> 
                </div> : null : null
              }
                </> : null
                : 
                <>
                  {
                    alredyGenenatedRc.length > 0 ?
                    <>
                    { ppldata !== null ? ppldata.financialsFile[0].rc_upload_date != null ?
                    <div className="me-1 mb-1" style={{width: "fit-content"}}>
                      <button className="btn btn-primary " type="button" style={{width : "100%"}} onClick={()=>{window.open(`/Ratings/edit_ppl/${client_id}/${og_rating_id}`, '_blanl')}}> PPL</button>
                    </div> : null : null
                    }
                      {
                        ppldata.opDetails[0].rating_scale_id == 19 ?
                        <div className="me-1 mb-1" style={{width: "fit-content"}}>
                          <button className="btn btn-primary " type="button" style={{width : "100%"}} onClick={()=>{window.open(`/Ratings/bfr/${client_id}/${og_rating_id}`, '_blank')}}> RR & KRD(BFR) </button>
                        </div>
                         : ppldata.opDetails[0].rating_scale_id== 28 ?
                         <div className="me-1 mb-1" style={{width: "fit-content"}}>
                          <button className="btn btn-primary " type="button" style={{width : "100%"}} onClick={()=>{window.open(`/Ratings/bfr/${client_id}/${og_rating_id}`, '_blank')}}> RR & KRD(SIP) </button>
                        </div>
                         :
                        ppldata.opDetails[0].rating_scale_id== 7 ?
                        <div className="me-1 mb-1" style={{width: "fit-content"}}>
                          <button className="btn btn-primary " type="button" style={{width : "100%"}} onClick={()=>{window.open(`/Ratings/perf_rank/${client_id}/${og_rating_id}`, '_blank')}}> RR & KRD(Performance Ranking) </button>
                        </div>
                         :
                        //  isadmin == "true" ? 
                        //   <div className="me-1 mb-1" style={{width: "fit-content"}}>
                        //     <form className="formclass" action={`${url}/api/generate-ai-rationale/${og_rating_id}`} method="post" target="_blank">
                        //         <input type="hidden" name={"id"} value={og_rating_id} />
                        //         <button type="submit">Generate AI RR & KRD <i class="fa fa-magic" style={{fontSize:  20}}></i> </button>
                        //     </form>
                        //   </div> :
                        <div className="me-1 mb-1" style={{width: "fit-content"}}>
                          <button className="btn btn-primary " type="button" onClick={()=>{window.open(`/Ratings/rr_krd/${client_id}/${og_rating_id}/add/${ppldata.financialsFile[0].rating_type_id}`, '_blank')}}> RR & KRD </button>
                          {((isadmin == "true" && data.rating_scales_title == "Entity" && data.model_name.includes("Corporate") && (data.ratingUpdateType_title == "Interim" || data.ratingUpdateType_title == "Annual" || data.ratingUpdateType_title == "Surveillance") && data.segment_id == 2) || (data.rating_scales_title == "Entity" && data.model_name.includes("Corporate") && data.segment_id == 2 && (data.ratingUpdateType_title == "Interim" || data.ratingUpdateType_title == "Annual" || data.ratingUpdateType_title == "Surveillance") && data.initiation_date >= "2026-07-01")) ? 
                          <>{(count == 0 || count  == null ) && <button  className="btn btn-primary ms-1" type="button" onClick={()=>{generateRRandKRD()}}>Generate AI RR & KRD <i class="fa fa-magic" style={{fontSize:  20}}></i> </button>}</> : null}
                        </div>
                      }
                    </> : null
                  }
                </>
                
              }
              {
                ppldata !== null ? ppldata.pr !== false ?
                <>
                {RRandKrd !== 0 && 
                  <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" style={{width : "100%"}} onClick={()=>{
                    window.open(`${url}/api/draftPr/${og_rating_id}`, '_blank')}
                    }>Draft PR</button>
                </div>}
                </>
                 :
                <>
                {RRandKrd !== 0 &&
                <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" style={{width : "100%"}} onClick={()=>{
                    window.open(`${url}/api/draftPr/${og_rating_id}`, '_blank')}
                    }>Draft PR</button>
                </div>
                }

                {
                  ppldata.ratingType == 4 ? 
                  <div className="me-1 mb-1" style={{width: "fit-content"}}>
                    <button className="btn btn-primary " style={{width : "100%"}} data-bs-toggle="modal" data-bs-target="#staticBackdropDetail">Add Details</button>
                  </div> : null
                }
                </>
              : null}
              {
                alredyGenenatednl.length > 0 ?
                alredyGenenatednl[0].second_approve == "Approved" ?
                <>
                {
                  pplcount > 1 ?
                  allppl.map((value, index)=>{
                    return(
                      <div className="me-1 mb-1" style={{width: "fit-content"}}>
                      <button className="btn btn-primary " type="button" onClick={()=>{
                        window.open(`/Ratings/pplview/${value.id}`);
                      }} >View PPL ({DateFormat(value.date)})</button>
                     </div>
                    )
                  }) :
                  <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" onClick={()=>{
                    window.open(`/Ratings/pplview/${alredyGenenatedPpl[0].id}`);
                  }} >View PPL</button>
                </div> 
                }
                </> : null : null
              }
              
              {
                alredyGenenatednl.length > 0 ?
                alredyGenenatednl[0].second_approve != "Approved" ?
                <>
                {ppldata.opDetails[0].rating_scale_id !== 6 && ppldata.opDetails[0].rating_scale_id !== 7 ? <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  {(data.rating_scales_title == "Entity" && data.segment_id == 2 && (data.ratingUpdateType_title == "Interim" || data.ratingUpdateType_title == "Annual" || data.ratingUpdateType_title == "Surveillance") && data.initiation_date >= "2026-07-01" && data.model_name.includes("Corporate")) ? null : <button className="btn btn-primary " type="button" style={{width : "100%"}} data-bs-toggle="modal" data-bs-target="#staticBackdropF">Upload Financials</button>}
                </div> : null}
                  {
                    ppldata.opDetails[0].rating_scale_id == 9 ?
                    <div className="me-1 mb-1" style={{width: "fit-content"}}>
                      <button className="btn btn-primary " type="button" style={{width : "100%"}} data-bs-toggle="modal" data-bs-target="#staticBackdropD">Upload Disclosure</button>
                    </div> : null
                  }
                </> : null : 
                <>
                  {ppldata.opDetails[0].rating_scale_id !== 6 && ppldata.opDetails[0].rating_scale_id !== 7 ? <div className="me-1 mb-1" style={{width: "fit-content"}}>
                    {(data.rating_scales_title == "Entity" && data.segment_id == 2 && (data.ratingUpdateType_title == "Interim" || data.ratingUpdateType_title == "Annual" || data.ratingUpdateType_title == "Surveillance") && data.initiation_date >= "2026-07-01" && data.model_name.includes("Corporate")) ? null : <button className="btn btn-primary " type="button" style={{width : "100%"}} data-bs-toggle="modal" data-bs-target="#staticBackdropF">Upload Financials</button>}
                  </div> : null}
                  {
                    ppldata.opDetails[0].rating_scale_id == 9 ?
                    <div className="me-1 mb-1" style={{width: "fit-content"}}>
                      <button className="btn btn-primary " style={{width : "100%"}} data-bs-toggle="modal" data-bs-target="#staticBackdropD">Upload Disclosure</button>
                    </div> : null
                  }

                </>
              }

              {
                alredyGenenatednl.length > 0 ?
                alredyGenenatednl[0].second_approve != "Approved" ?
                <> 
                  {ppldata !== null ?
                    ppldata.opDetails[0].rating_scale_id !== 6 && ppldata.opDetails[0].rating_scale_id !== 7 && ppldata.opDetails[0].pacra_action !== 5
                    && ppldata.opDetails[0].pacra_action !== 6 && ppldata.opDetails[0].pacra_action !== 11 && ppldata.opDetails[0].pacra_action !== 18 &&
                    <div className="me-1 mb-1" style={{width: "fit-content"}}>
                      <button type="button" className="btn btn-primary "  style={{width : "100%"}} onClick={()=>{generateReport()}}> <div id="gn">Generate Report</div> <div id="generateprogress" hidden>Please Wait...</div></button>
                    </div> : null
                  }
                </>
                 : null :
                 <> 
                  { ppldata !== null ?
                    ppldata.opDetails[0].rating_scale_id !== 6 && ppldata.opDetails[0].rating_scale_id !== 7 && ppldata.opDetails[0].pacra_action !== 5
                    && ppldata.opDetails[0].pacra_action !== 6 && ppldata.opDetails[0].pacra_action !== 11 && ppldata.opDetails[0].pacra_action !== 18 &&
                    <div className="me-1 mb-1" style={{width: "fit-content"}}>
                    <button type="button" className="btn btn-primary "  style={{width : "100%"}} onClick={()=>{generateReport()}}> <div id="gn">Generate Report</div> <div id="generateprogress" hidden>Please Wait...</div></button>
                    </div> : null
                  }
                 </>
              }
            </> : null
          }
          {
            ppldata !== null ?
              ppldata.lastRecord['pacra_outlook'] == ppldata.secondLastRecord['pacra_outlook'] &&
              ppldata.lastRecord['pacra_five_yr'] == ppldata.secondLastRecord['pacra_five_yr'] &&
              ppldata.lastRecord['pacra_lterm'] == ppldata.secondLastRecord['pacra_lterm'] &&
              (ppldata.lastRecord['pacra_sterm'] == ppldata.secondLastRecord['pacra_sterm'] ||
              ppldata.secondLastRecord['pacra_sterm'] == '5') ?
              
              ppldata.secondLastRW !== "unset" && ppldata.lastRecord.review_cancelled != 1 && ppldata.lastRW == ppldata.secondLastRW ?
              null :
              <>
              {
              alredyGenenatednl.length > 0 ? 
                  alredyGenenatednl[0].second_approve != "Approved" ?
                <>
                {
                  ppldata !== null ? (data.rating_scales_title == "Stability Rating") && 
                  <div>
                    <button className="btn btn-primary me-2" data-bs-toggle="modal" data-bs-target="#excelsheet">Upload Graphs (Excel Sheet)</button>
                    <button className="btn btn-primary me-2" onClick={()=>{window.open(`/fs-facts/${client_id}/${og_rating_id}`)}}>Add Fund Facts</button>
                    <button className="btn btn-primary me-2" onClick={()=>{window.open(`/fund-history/${client_id}`)}}>Fund History</button>
                    <button className="btn btn-primary me-2" data-bs-toggle="modal" data-bs-target="#add-asset">Asset Management Details</button>
                    <button className="btn btn-primary me-2" data-bs-toggle="modal" data-bs-target="#add-commentary">Add Commentary</button>
                    {
                      ppldata.opDetails[0].pacra_action !== 6 && ppldata.opDetails[0].pacra_action !== 11 && ppldata.opDetails[0].pacra_action !== 18 &&
                      <button type="button" className="btn btn-primary" onClick={()=>{generateReport()}}> <div id="gn">Generate Report</div> <div id="generateprogress" hidden>Please Wait...</div></button> 
                    }
                    
                  </div>
                  : null
                  }
                </>
                : null :
              <>
                {
                  ppldata !== null ? (data.rating_scales_title == "Stability Rating") && 
                  <div>
                    <button className="btn btn-primary me-2" data-bs-toggle="modal" data-bs-target="#excelsheet">Upload Graphs (Excel Sheet)</button>
                    <button className="btn btn-primary me-2" onClick={()=>{window.open(`/fs-facts/${client_id}/${og_rating_id}`)}}>Add Fund Facts</button>
                    <button className="btn btn-primary me-2" onClick={()=>{window.open(`/fund-history/${client_id}`)}}>Fund History</button>
                    <button className="btn btn-primary me-2" data-bs-toggle="modal" data-bs-target="#add-asset">Asset Management Details</button>
                    <button className="btn btn-primary me-2" data-bs-toggle="modal" data-bs-target="#add-commentary">Add Commentary</button>
                    {
                      ppldata.opDetails[0].pacra_action !== 6 && ppldata.opDetails[0].pacra_action !== 11 && ppldata.opDetails[0].pacra_action !== 18 &&
                      <button type="button" className="btn btn-primary" onClick={()=>{generateReport()}}> <div id="gn">Generate Report</div> <div id="generateprogress" hidden>Please Wait...</div></button> 
                    }
                    
                  </div>
                  : null
                  }
              </>
              }
              </>
              :
              <>
              {
              alredyGenenatednl.length > 0 ? 
                  alredyGenenatednl[0].second_approve != "Approved" ?
                <>
                {
                  ppldata !== null ? (data.rating_scales_title == "Stability Rating") && 
                  <div>
                    <button className="btn btn-primary me-2" data-bs-toggle="modal" data-bs-target="#excelsheet">Upload Graphs (Excel Sheet)</button>
                    <button className="btn btn-primary me-2" onClick={()=>{window.open(`/fs-facts/${client_id}/${og_rating_id}`)}}>Add Fund Facts</button>
                    <button className="btn btn-primary me-2" onClick={()=>{window.open(`/fund-history/${client_id}`)}}>Fund History</button>
                    <button className="btn btn-primary me-2" data-bs-toggle="modal" data-bs-target="#add-asset">Asset Management Details</button>
                    <button className="btn btn-primary me-2" data-bs-toggle="modal" data-bs-target="#add-commentary">Add Commentary</button>
                    {
                      ppldata.opDetails[0].pacra_action !== 6 && ppldata.opDetails[0].pacra_action !== 11 && ppldata.opDetails[0].pacra_action !== 18 &&
                      <button type="button" className="btn btn-primary" onClick={()=>{generateReport()}}> <div id="gn">Generate Report</div> <div id="generateprogress" hidden>Please Wait...</div></button> 
                    }
                    
                  </div>
                  : null
                  }
                </>
                : null :
              <>
                {
                  ppldata !== null ? (data.rating_scales_title == "Stability Rating") && 
                  <div>
                    <button className="btn btn-primary me-2" data-bs-toggle="modal" data-bs-target="#excelsheet">Upload Graphs (Excel Sheet)</button>
                    <button className="btn btn-primary me-2" onClick={()=>{window.open(`/fs-facts/${client_id}/${og_rating_id}`)}}>Add Fund Facts</button>
                    <button className="btn btn-primary me-2" onClick={()=>{window.open(`/fund-history/${client_id}`)}}>Fund History</button>
                    <button className="btn btn-primary me-2" data-bs-toggle="modal" data-bs-target="#add-asset">Asset Management Details</button>
                    <button className="btn btn-primary me-2" data-bs-toggle="modal" data-bs-target="#add-commentary">Add Commentary</button>
                    {
                      ppldata.opDetails[0].pacra_action !== 6 && ppldata.opDetails[0].pacra_action !== 11 && ppldata.opDetails[0].pacra_action !== 18 &&
                      <button type="button" className="btn btn-primary" onClick={()=>{generateReport()}}> <div id="gn">Generate Report</div> <div id="generateprogress" hidden>Please Wait...</div></button> 
                    }
                    
                  </div>
                  
                  : null
                  }
              </>
              }
              </>
            : null
          }
          
        
        
        </div> :
        <div className="mx-auto"> <CircularProgress /> </div>}
      </div> :
        reopen == null ?
      <div className="card m-2 shadow p-2">
        {ppldata !== null ? alredyGenenatedRc.length == 0 && <Box className="mx-auto" sx={{ width: "98%" }}>
                    <Collapse in={true}>
                      <Alert
                        severity={'error'}
                        sx={{ mb: 2 }}
                      >
                        {'Please generate RC to enable RR & KRD'}
                      </Alert>
                    </Collapse>
          </Box> : null}
        {ppldata !== null ? ppldata.financialsFile[0].rc_upload_date == null && <Box className="mx-auto" sx={{ width: "98%" }}>
                    <Collapse in={true}>
                      <Alert
                        severity={'error'}
                        sx={{ mb: 2 }}
                      >
                        {'RC approval is required for PPL'}
                      </Alert>
                    </Collapse>
          </Box> : null}
          <Box className="mx-auto mt-1 mb-1" sx={{ width: "98%" }}>
                <Collapse in={alertopen}>
                    <Alert
                        severity={alertType}
                        action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setalertopen(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        sx={{ mb: 2 }}
                      >
                        {AlertMessage}
                    </Alert>
                </Collapse>
          </Box>
          {isadmin == "true" ? <div><button type="button" className="mb-2 btn btn-primary" onClick={()=>{window.open(`https://209.97.168.200/pacrawizpackv3/public/regenerate-rating-report/${og_rating_id}`, '_blank')}}>Hard Generate RR</button></div> : null}

        {ppldata !== null ? <div className="d-flex">
          {
            ppldata !== null ?
            ppldata.lastRecord['pacra_outlook'] == ppldata.secondLastRecord['pacra_outlook'] &&
            ppldata.lastRecord['pacra_five_yr'] == ppldata.secondLastRecord['pacra_five_yr'] &&
            ppldata.lastRecord['pacra_lterm'] == ppldata.secondLastRecord['pacra_lterm'] &&
            (ppldata.lastRecord['pacra_sterm'] == ppldata.secondLastRecord['pacra_sterm'] ||
            ppldata.secondLastRecord['pacra_sterm'] == '5') ?
            
            ppldata.secondLastRW !== "unset" && ppldata.lastRecord.review_cancelled != 1 && ppldata.lastRW == ppldata.secondLastRW ?
            <>
              {
                alredyGenenatedRc.length > 1 ? getPpls.length == 2 ?
                <> { (Number(data.rating_update_type) != 6 && Number(data.rating_update_type) != 4) || (ppldata.review == 0) ? <div className="me-1 mb-1" style={{width: "fit-content"}}><button className="btn btn-primary " type="button" onClick={()=>{window.open(`/Ratings/edit_ppl/${client_id}/${og_rating_id}`, '_blank')}}> Post Appeal PPL </button> </div> : null }</> :
                <>{ (Number(data.rating_update_type) != 6 && Number(data.rating_update_type) != 4) || (ppldata.review == 0) ? <div className="me-1 mb-1" style={{width: "fit-content"}}><button className="btn btn-primary " type="button" onClick={()=>{window.open(`/Ratings/closer_internally/${ppldata.lastRecord['client_id']}/${ppldata.lastRecord['id']}`, '_blank')}}> Close Internally </button> </div> : null} </> : null
              }

              {
                alredyGenenatedRc.length <= 1 && <> {(Number(data.rating_update_type) != 6 && Number(data.rating_update_type) != 4) || (ppldata.review == 0) ? <div className="me-1 mb-1" style={{width: "fit-content"}}> <button className="btn btn-primary " type="button" onClick={()=>{window.open(`/Ratings/closer_internally/${ppldata.lastRecord['client_id']}/${ppldata.lastRecord['id']}`, '_blank')}}> Close Internally </button> </div> : null}</>
              }
              {
                ppldata.lastRecord.reviewId=='' || ppldata.lastRecord.reviewId== null ? <> { (Number(data.rating_update_type) != 6 && Number(data.rating_update_type) != 4) || (ppldata.review == 0) ? <div className="me-1 mb-1" style={{width: "fit-content"}}> <button className="btn btn-primary " type="button" onClick={()=>{cancelReview()}}> Dissemination </button> </div> : null}</> : null
              }
            </>
            :
            <>
              {
                alredyGenenatedPpl.length == 0 ?
                ppldata.financialsFile[0].rc_upload_date != null ?
                <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" onClick={()=>{window.open(`/Ratings/generate_ppl/${client_id}/${og_rating_id}`, '_blank')}}> Generate PPL </button> 
                </div> : null : null
              }
              {
                alredyGenenatedPpl.length > 0 ?
                alredyGenenatedPpl[0].second_approve !== 'Approved' ?
                <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" onClick={()=>{window.open(`/Ratings/edit_ppl/${client_id}/${og_rating_id}`, '_blank')}}> Edit PPL </button> 
                </div> : 
                alredyGenenatednl.length == 0 ?
                <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary" type="button" onClick={()=>{window.open(`/Ratings/edit_ppl/${client_id}/${og_rating_id}`, '_blank')}}> PPL </button> 
                </div> :
                <> 
                {
                alredyGenenatednl.length > 0 ?
                alredyGenenatednl[0].second_approve != "Approved" ?
                <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" onClick={()=>{window.open(`/Ratings/edit_ppl/${client_id}/${og_rating_id}`, '_blank')}}> PPL </button> 
                </div> :
                <>
                {
                  pplcount > 1 ?
                  allppl.map((value, index)=>{
                    return(
                      <div className="me-1 mb-1" style={{width: "fit-content"}}>
                      <button className="btn btn-primary " type="button" onClick={()=>{
                        window.open(`/Ratings/pplview/${value.id}`);
                      }} >View PPL ({DateFormat(value.date)})</button>
                     </div>
                    )
                  }) :
                  <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" onClick={()=>{
                    window.open(`/Ratings/pplview/${alredyGenenatedPpl[0].id}`);
                  }} >View PPL</button>
                </div> 
                }
                </> : null
                }
                </> : null
              }
              {/* {
                alredyGenenatedPpl.length > 0 ?
                alredyGenenatedPpl[0].second_approve == 'Approved' && alredyGenenatednl.length == 0 ?
                <>
                {
                  pplcount > 1 ?
                  allppl.map((value, index)=>{
                    return(
                      <div className="me-1 mb-1" style={{width: "fit-content"}}>
                      <button className="btn btn-primary " type="button" onClick={()=>{
                        window.open(`/Ratings/pplview/${value.id}`);
                      }} >View PPL ({DateFormat(value.date)})</button>
                     </div>
                    )
                  }) :
                  <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" onClick={()=>{
                    window.open(`/Ratings/pplview/${alredyGenenatedPpl[0].id}`);
                  }} >View PPL 2</button>
                </div> 
                }
                </>
                : null : null
              } */}

              {
                alredyGenenatednl.length > 0 ?
                alredyGenenatednl[0].second_approve != "Approved" ?
                ppldata.opDetails[0].rating_scale_id == 19 ?
                <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" onClick={()=>{window.open(`/Ratings/bfr/${client_id}/${og_rating_id}`, '_blank')}}> RR & KRD(BFR) </button> 
                </div> :
                ppldata.opDetails[0].rating_scale_id == 28 ?
                <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" onClick={()=>{window.open(`/Ratings/bfr/${client_id}/${og_rating_id}`, '_blank')}}> RR & KRD(SIP) </button> 
                </div> :
                ppldata.opDetails[0].rating_scale_id == 7 ?
                <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" onClick={()=>{window.open(`/Ratings/perf_rank/${client_id}/${og_rating_id}`, '_blank')}}> RR & KRD(Performance Ranking) </button> 
                </div> :
                <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" onClick={()=>{window.open(`/Ratings/rr_krd/${client_id}/${og_rating_id}/add/${ppldata.financialsFile[0].rating_type_id}`, '_blank')}}> RR & KRD </button> 
                  {((isadmin == "true" && data.rating_scales_title == "Entity" && data.model_name.includes("Corporate") && data.segment_id == 2 && (data.ratingUpdateType_title == "Interim" || data.ratingUpdateType_title == "Annual" || data.ratingUpdateType_title == "Surveillance")) || (data.rating_scales_title == "Entity" && data.model_name.includes("Corporate") && data.segment_id == 2 && (data.ratingUpdateType_title == "Interim" || data.ratingUpdateType_title == "Annual" || data.ratingUpdateType_title == "Surveillance") && data.initiation_date >= "2026-07-01")) ? 
                  <>{(count == 0 || count  == null ) && <button  className="btn btn-primary ms-1" type="button" onClick={()=>{generateRRandKRD()}}>Generate AI RR & KRD <i class="fa fa-magic" style={{fontSize:  20}}></i> </button>}</> : null}
                </div> : null :
                alredyGenenatedRc.length > 0 ?
                ppldata.opDetails[0].rating_scale_id == 19 ?
                <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" onClick={()=>{window.open(`/Ratings/bfr/${client_id}/${og_rating_id}`, '_blank')}}> RR & KRD(BFR) </button> 
                </div> :
                ppldata.opDetails[0].rating_scale_id == 28 ?
                <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" onClick={()=>{window.open(`/Ratings/bfr/${client_id}/${og_rating_id}`, '_blank')}}> RR & KRD(SIP) </button> 
                </div> :
                ppldata.opDetails[0].rating_scale_id== 7 ?
                <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" onClick={()=>{window.open(`/Ratings/perf_rank/${client_id}/${og_rating_id}`, '_blank')}}> RR & KRD(Performance Ranking) </button> 
                </div> :
                // isadmin == "true" ? 
                // <div className="me-1 mb-1" style={{width: "fit-content"}}>
                //   <form className="formclass" action={`${url}/api/generate-ai-rationale/${og_rating_id}`} method="post" target="_blank">
                //       <input type="hidden" name={"id"} value={og_rating_id} />
                //       <button type="submit">Generate AI RR & KRD <i class="fa fa-magic" style={{fontSize:  20}}></i> </button>
                //   </form>
                // </div>:
                <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" onClick={()=>{window.open(`/Ratings/rr_krd/${client_id}/${og_rating_id}/add/${ppldata.financialsFile[0].rating_type_id}`, '_blank')}}> RR & KRD </button> 
                  {((isadmin == "true" && data.rating_scales_title == "Entity" && data.model_name.includes("Corporate") && data.segment_id == 2 && (data.ratingUpdateType_title == "Interim" || data.ratingUpdateType_title == "Annual" || data.ratingUpdateType_title == "Surveillance")) || (data.rating_scales_title == "Entity" && data.model_name.includes("Corporate") && data.segment_id == 2 && (data.ratingUpdateType_title == "Interim" || data.ratingUpdateType_title == "Annual" || data.ratingUpdateType_title == "Surveillance") && data.initiation_date >= "2026-07-01")) ? 
                  <>{(count == 0 || count  == null ) && <button  className="btn btn-primary ms-1" type="button" onClick={()=>{generateRRandKRD()}}>Generate AI RR & KRD <i class="fa fa-magic" style={{fontSize:  20}}></i> </button>}</> : null}
                </div> : null

              }

              {
                RRandKrd !== 0 && <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " target="_blank" onClick={()=>{
                    window.open(`${url}/api/draftPr/${og_rating_id}`, '_blank')}
                    }> Draft PR </button> 
                </div>
              }
              
              {
                alredyGenenatednl.length > 0 ?
                alredyGenenatednl[0].second_approve != "Approved" ? 
                <>
                {ppldata.opDetails[0].rating_scale_id !== 6 && ppldata.opDetails[0].rating_scale_id !== 7 ? <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  {(data.rating_scales_title == "Entity" && data.segment_id == 2 && (data.ratingUpdateType_title == "Interim" || data.ratingUpdateType_title == "Annual" || data.ratingUpdateType_title == "Surveillance") && data.initiation_date >= "2026-07-01" && data.model_name.includes("Corporate")) ? null : <button className="btn btn-primary " type="button" style={{width : "100%"}} data-bs-toggle="modal" data-bs-target="#staticBackdropF">Upload Financials</button>}
                </div> : null}
                {ppldata.opDetails[0].rating_scale_id== 9 ? 
                <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" data-bs-toggle="modal" data-bs-target="#staticBackdropD">Upload Disclosure</button> 
                </div> : null}
                </> : null :
                <>
                {ppldata.opDetails[0].rating_scale_id !== 6 && ppldata.opDetails[0].rating_scale_id !== 7 ? <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  {(data.rating_scales_title == "Entity" && data.segment_id == 2 && (data.ratingUpdateType_title == "Interim" || data.ratingUpdateType_title == "Annual" || data.ratingUpdateType_title == "Surveillance") && data.initiation_date >= "2026-07-01" && data.model_name.includes("Corporate")) ? null : <button className="btn btn-primary " type="button" style={{width : "100%"}} data-bs-toggle="modal" data-bs-target="#staticBackdropF">Upload Financials</button>}
                </div> : null}
                {ppldata.opDetails[0].rating_scale_id== 9 &&
                <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" data-bs-toggle="modal" data-bs-target="#staticBackdropD">Upload Disclosure</button>
                </div>}
                </>
              }
              {
                alredyGenenatednl.length > 0 ? 
                alredyGenenatednl[0].second_approve != "Approved" ?
                <> 
                  { ppldata !== null ?
                    ppldata.opDetails[0].rating_scale_id !== 6 && ppldata.opDetails[0].rating_scale_id !== 7 && ppldata.opDetails[0].pacra_action !== 5
                    && ppldata.opDetails[0].pacra_action !== 6 && ppldata.opDetails[0].pacra_action !== 11 && ppldata.opDetails[0].pacra_action !== 18 &&
                  <div className="me-1 mb-1" style={{width: "fit-content"}}>
                    <button type="button" className="btn btn-primary " onClick={()=>{generateReport()}}> <div id="gn">Generate Report</div> <div id="generateprogress" hidden>Please Wait...</div></button> 
                  </div> : null
                    }
                </>
                 : null :
                 <> 
                  { ppldata !== null ?
                    ppldata.opDetails[0].rating_scale_id !== 6 && ppldata.opDetails[0].rating_scale_id !== 7 && ppldata.opDetails[0].pacra_action !== 5
                    && ppldata.opDetails[0].pacra_action !== 6 && ppldata.opDetails[0].pacra_action !== 11 && ppldata.opDetails[0].pacra_action !== 18 &&
                    <div className="me-1 mb-1" style={{width: "fit-content"}}>
                    <button type="button" className="btn btn-primary " onClick={()=>{generateReport()}}> <div id="gn">Generate Report</div> <div id="generateprogress" hidden>Please Wait...</div></button>
                    </div> : null
                  }
                 </>
              }
            </> 
            :
            <>
 
              {
                alredyGenenatednl.length > 0 ?
                alredyGenenatednl[0].second_approve != "Approved" ?
                <>
              {
                  ppldata.opDetails[0].rating_scale_id == 19 ?
                  <div className="me-1 mb-1" style={{width: "fit-content"}}>
                    <button className="btn btn-primary " type="button" onClick={()=>{window.open(`/Ratings/bfr/${client_id}/${og_rating_id}`, '_blank')}}> RR & KRD(BFR) </button> 
                  </div> :
                  ppldata.opDetails[0].rating_scale_id == 28 ?
                  <div className="me-1 mb-1" style={{width: "fit-content"}}>
                    <button className="btn btn-primary " type="button" onClick={()=>{window.open(`/Ratings/bfr/${client_id}/${og_rating_id}`, '_blank')}}> RR & KRD(SIP) </button> 
                  </div> :
                ppldata.opDetails[0].rating_scale_id== 7 ?
                <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" onClick={()=>{window.open(`/Ratings/perf_rank/${client_id}/${og_rating_id}`, '_blank')}}> RR & KRD(Performance Ranking) </button>
                </div> :
                // isadmin == "true" ? 
                // <div className="me-1 mb-1" style={{width: "fit-content"}}>
                //   <form className="formclass" action={`${url}/api/generate-ai-rationale/${og_rating_id}`} method="post" target="_blank">
                //       <input type="hidden" name={"id"} value={og_rating_id} />
                //       <button type="submit">Generate AI RR & KRD <i class="fa fa-magic" style={{fontSize:  20}}></i> </button>
                //   </form>
                // </div>:
                <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" onClick={()=>{window.open(`/Ratings/rr_krd/${client_id}/${og_rating_id}/add/${ppldata.financialsFile[0].rating_type_id}`, '_blank')}}> RR & KRD </button>
                  {((isadmin == "true" && data.rating_scales_title == "Entity" && data.model_name.includes("Corporate") && data.segment_id == 2 && (data.ratingUpdateType_title == "Interim" || data.ratingUpdateType_title == "Annual" || data.ratingUpdateType_title == "Surveillance")) || (data.rating_scales_title == "Entity" && data.model_name.includes("Corporate") && data.segment_id == 2 &&  (data.ratingUpdateType_title == "Interim" || data.ratingUpdateType_title == "Annual" || data.ratingUpdateType_title == "Surveillance") && data.initiation_date >= "2026-07-01")) ? 
                  <>{(count == 0 || count  == null ) && <button  className="btn btn-primary ms-1" type="button" onClick={()=>{generateRRandKRD()}}>Generate AI RR & KRD <i class="fa fa-magic" style={{fontSize:  20}}></i> </button>}</> : null}
                </div>
              }

              { ppldata !== null ? ppldata.financialsFile[0].rc_upload_date != null ?
                <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" onClick={()=>{window.open(`/Ratings/edit_ppl/${client_id}/${og_rating_id}`, '_blank')}}> PPL </button> 
                </div> : null : null
              }
                </> : null
                : 
                <>
                  {
                    alredyGenenatedRc.length > 0 ?
                    <>
                    { ppldata !== null ? ppldata.financialsFile[0].rc_upload_date != null ?
                    <div className="me-1 mb-1" style={{width: "fit-content"}}>
                      <button className="btn btn-primary " type="button" style={{width : "100%"}} onClick={()=>{window.open(`/Ratings/edit_ppl/${client_id}/${og_rating_id}`, '_blanl')}}> PPL</button>
                    </div> : null : null
                    }
                      {
                        ppldata.opDetails[0].rating_scale_id == 19 ?
                        <div className="me-1 mb-1" style={{width: "fit-content"}}>
                          <button className="btn btn-primary " type="button" style={{width : "100%"}} onClick={()=>{window.open(`/Ratings/bfr/${client_id}/${og_rating_id}`, '_blank')}}> RR & KRD(BFR) </button>
                        </div>
                         : ppldata.opDetails[0].rating_scale_id== 28 ?
                         <div className="me-1 mb-1" style={{width: "fit-content"}}>
                          <button className="btn btn-primary " type="button" style={{width : "100%"}} onClick={()=>{window.open(`/Ratings/bfr/${client_id}/${og_rating_id}`, '_blank')}}> RR & KRD(SIP) </button>
                        </div>
                         :
                        ppldata.opDetails[0].rating_scale_id== 7 ?
                        <div className="me-1 mb-1" style={{width: "fit-content"}}>
                          <button className="btn btn-primary " type="button" style={{width : "100%"}} onClick={()=>{window.open(`/Ratings/perf_rank/${client_id}/${og_rating_id}`, '_blank')}}> RR & KRD(Performance Ranking) </button>
                        </div>
                         :
                        //  isadmin == "true" ? 
                        //   <div className="me-1 mb-1" style={{width: "fit-content"}}>
                        //     <form className="formclass" action={`${url}/api/generate-ai-rationale/${og_rating_id}`} method="post" target="_blank">
                        //         <input type="hidden" name={"id"} value={og_rating_id} />
                        //         <button type="submit">Generate AI RR & KRD <i class="fa fa-magic" style={{fontSize:  20}}></i> </button>
                        //     </form>
                        //   </div>:
                        <div className="me-1 mb-1" style={{width: "fit-content"}}>
                          <button className="btn btn-primary THISONE" type="button"  onClick={()=>{window.open(`/Ratings/rr_krd/${client_id}/${og_rating_id}/add/${ppldata.financialsFile[0].rating_type_id}`, '_blank')}}> RR & KRD </button>
                          {((isadmin == "true" && data.rating_scales_title == "Entity" && data.model_name.includes("Corporate") && data.segment_id == 2 &&  (data.ratingUpdateType_title == "Interim" || data.ratingUpdateType_title == "Annual" || data.ratingUpdateType_title == "Surveillance")) || (data.rating_scales_title == "Entity" && data.model_name.includes("Corporate") && data.segment_id == 2 && (data.ratingUpdateType_title == "Interim" || data.ratingUpdateType_title == "Annual" || data.ratingUpdateType_title == "Surveillance") && data.initiation_date >= "2026-07-01")) ? 
                          <>{(count == 0 || count  == null ) && <button  className="btn btn-primary ms-1" type="button" onClick={()=>{generateRRandKRD()}}>Generate AI RR & KRD <i class="fa fa-magic" style={{fontSize:  20}}></i> </button>}</> : null}
                        </div>
                      }
                    </> : null
                  }
                </>
                
              }
              {
                ppldata !== null ? ppldata.pr !== false ?
                <>
                {RRandKrd !== 0 && 
                  <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" style={{width : "100%"}} onClick={()=>{
                    window.open(`${url}/api/draftPr/${og_rating_id}`, '_blank')}
                    }>Draft PR</button>
                </div>}
                </>
                 :
                <>
                {RRandKrd !== 0 &&
                <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" style={{width : "100%"}} onClick={()=>{
                    window.open(`${url}/api/draftPr/${og_rating_id}`, '_blank')}
                    }>Draft PR</button>
                </div>
                }

                {
                  ppldata.ratingType == 4 ? 
                  <div className="me-1 mb-1" style={{width: "fit-content"}}>
                    <button className="btn btn-primary " style={{width : "100%"}} data-bs-toggle="modal" data-bs-target="#staticBackdropDetail">Add Details</button>
                  </div> : null
                }
                </>
              : null}
              {
                alredyGenenatednl.length > 0 ?
                alredyGenenatednl[0].second_approve == "Approved" ?
                <>
                {
                  pplcount > 1 ?
                  allppl.map((value, index)=>{
                    return(
                      <div className="me-1 mb-1" style={{width: "fit-content"}}>
                      <button className="btn btn-primary " type="button" onClick={()=>{
                        window.open(`/Ratings/pplview/${value.id}`);
                      }} >View PPL ({DateFormat(value.date)})</button>
                     </div>
                    )
                  }) :
                  <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" onClick={()=>{
                    window.open(`/Ratings/pplview/${alredyGenenatedPpl[0].id}`);
                  }} >View PPL</button>
                </div> 
                }
                </> : null : null
              }
              
              {
                alredyGenenatednl.length > 0 ?
                alredyGenenatednl[0].second_approve != "Approved" ?
                <>
                {ppldata.opDetails[0].rating_scale_id !== 6 && ppldata.opDetails[0].rating_scale_id !== 7 ? <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  {(data.rating_scales_title == "Entity" && data.segment_id == 2 && (data.ratingUpdateType_title == "Interim" || data.ratingUpdateType_title == "Annual" || data.ratingUpdateType_title == "Surveillance") && data.initiation_date >= "2026-07-01" && data.model_name.includes("Corporate")) ? null : <button className="btn btn-primary " type="button" style={{width : "100%"}} data-bs-toggle="modal" data-bs-target="#staticBackdropF">Upload Financials</button>}
                </div> : null}
                  {
                    ppldata.opDetails[0].rating_scale_id == 9 ?
                    <div className="me-1 mb-1" style={{width: "fit-content"}}>
                      <button className="btn btn-primary " type="button" style={{width : "100%"}} data-bs-toggle="modal" data-bs-target="#staticBackdropD">Upload Disclosure</button>
                    </div> : null
                  }
                </> : null : 
                <>
                  {ppldata.opDetails[0].rating_scale_id !== 6 && ppldata.opDetails[0].rating_scale_id !== 7 ? <div className="me-1 mb-1" style={{width: "fit-content"}}>
                    {(data.rating_scales_title == "Entity" && data.segment_id == 2 && (data.ratingUpdateType_title == "Interim" || data.ratingUpdateType_title == "Annual" || data.ratingUpdateType_title == "Surveillance") && data.initiation_date >= "2026-07-01" && data.model_name.includes("Corporate")) ? null : <button className="btn btn-primary " type="button" style={{width : "100%"}} data-bs-toggle="modal" data-bs-target="#staticBackdropF">Upload Financials</button>}
                  </div> : null}
                  {
                    ppldata.opDetails[0].rating_scale_id == 9 ?
                    <div className="me-1 mb-1" style={{width: "fit-content"}}>
                      <button className="btn btn-primary " style={{width : "100%"}} data-bs-toggle="modal" data-bs-target="#staticBackdropD">Upload Disclosure</button>
                    </div> : null
                  }

                </>
              }

              {
                alredyGenenatednl.length > 0 ?
                alredyGenenatednl[0].second_approve != "Approved" ?
                <> 
                  {ppldata !== null ?
                    ppldata.opDetails[0].rating_scale_id !== 6 && ppldata.opDetails[0].rating_scale_id !== 7 && ppldata.opDetails[0].pacra_action !== 5
                    && ppldata.opDetails[0].pacra_action !== 6 && ppldata.opDetails[0].pacra_action !== 11 && ppldata.opDetails[0].pacra_action !== 18 &&
                    <div className="me-1 mb-1" style={{width: "fit-content"}}>
                      <button type="button" className="btn btn-primary "  style={{width : "100%"}} onClick={()=>{generateReport()}}> <div id="gn">Generate Report</div> <div id="generateprogress" hidden>Please Wait...</div></button>
                    </div> : null
                  }
                </>
                 : null :
                 <> 
                  { ppldata !== null ?
                    ppldata.opDetails[0].rating_scale_id !== 6 && ppldata.opDetails[0].rating_scale_id !== 7 && ppldata.opDetails[0].pacra_action !== 5
                    && ppldata.opDetails[0].pacra_action !== 6 && ppldata.opDetails[0].pacra_action !== 11 && ppldata.opDetails[0].pacra_action !== 18 &&
                    <div className="me-1 mb-1" style={{width: "fit-content"}}>
                    <button type="button" className="btn btn-primary "  style={{width : "100%"}} onClick={()=>{generateReport()}}> <div id="gn">Generate Report</div> <div id="generateprogress" hidden>Please Wait...</div></button>
                    </div> : null
                  }
                 </>
              }
            </> : null
          }

           {
            ppldata !== null ?
              ppldata.lastRecord['pacra_outlook'] == ppldata.secondLastRecord['pacra_outlook'] &&
              ppldata.lastRecord['pacra_five_yr'] == ppldata.secondLastRecord['pacra_five_yr'] &&
              ppldata.lastRecord['pacra_lterm'] == ppldata.secondLastRecord['pacra_lterm'] &&
              (ppldata.lastRecord['pacra_sterm'] == ppldata.secondLastRecord['pacra_sterm'] ||
              ppldata.secondLastRecord['pacra_sterm'] == '5') ?
              
              ppldata.secondLastRW !== "unset" && ppldata.lastRecord.review_cancelled != 1 && ppldata.lastRW == ppldata.secondLastRW ?
              null :
              <>
              {
              alredyGenenatednl.length > 0 ? 
                  alredyGenenatednl[0].second_approve != "Approved" ?
                <>
                {
                  ppldata !== null ? (data.rating_scales_title == "Stability Rating") && 
                  <div>
                    <button className="btn btn-primary me-2" data-bs-toggle="modal" data-bs-target="#excelsheet">Upload Graphs (Excel Sheet)</button>
                    <button className="btn btn-primary me-2" onClick={()=>{window.open(`/fs-facts/${client_id}/${og_rating_id}`)}}>Add Fund Facts</button>
                    <button className="btn btn-primary me-2" onClick={()=>{window.open(`/fund-history/${client_id}`)}}>Fund History</button>
                    <button className="btn btn-primary me-2" data-bs-toggle="modal" data-bs-target="#add-asset">Asset Management Details</button>
                    <button className="btn btn-primary me-2" data-bs-toggle="modal" data-bs-target="#add-commentary">Add Commentary</button>
                    {
                      ppldata.opDetails[0].pacra_action !== 6 && ppldata.opDetails[0].pacra_action !== 11 && ppldata.opDetails[0].pacra_action !== 18 &&
                      <button type="button" className="btn btn-primary" onClick={()=>{generateReport()}}> <div id="gn">Generate Report</div> <div id="generateprogress" hidden>Please Wait...</div></button> 
                    }
                    
                  </div>
                  : null
                  }
                </>
                : null :
              <>
                {
                  ppldata !== null ? (data.rating_scales_title == "Stability Rating") && 
                  <div>
                    <button className="btn btn-primary me-2" data-bs-toggle="modal" data-bs-target="#excelsheet">Upload Graphs (Excel Sheet)</button>
                    <button className="btn btn-primary me-2" onClick={()=>{window.open(`/fs-facts/${client_id}/${og_rating_id}`)}}>Add Fund Facts</button>
                    <button className="btn btn-primary me-2" onClick={()=>{window.open(`/fund-history/${client_id}`)}}>Fund History</button>
                    <button className="btn btn-primary me-2" data-bs-toggle="modal" data-bs-target="#add-asset">Asset Management Details</button>
                    <button className="btn btn-primary me-2" data-bs-toggle="modal" data-bs-target="#add-commentary">Add Commentary</button>
                    {
                      ppldata.opDetails[0].pacra_action !== 6 && ppldata.opDetails[0].pacra_action !== 11 && ppldata.opDetails[0].pacra_action !== 18 &&
                      <button type="button" className="btn btn-primary" onClick={()=>{generateReport()}}> <div id="gn">Generate Report</div> <div id="generateprogress" hidden>Please Wait...</div></button> 
                    }
                    
                  </div>
                  : null
                  }
              </>
              }
              </>
              :
              <>
              {
              alredyGenenatednl.length > 0 ? 
                  alredyGenenatednl[0].second_approve != "Approved" ?
                <>
                {
                  ppldata !== null ? (data.rating_scales_title == "Stability Rating") && 
                  <div>
                    <button className="btn btn-primary me-2" data-bs-toggle="modal" data-bs-target="#excelsheet">Upload Graphs (Excel Sheet)</button>
                    <button className="btn btn-primary me-2" onClick={()=>{window.open(`/fs-facts/${client_id}/${og_rating_id}`)}}>Add Fund Facts</button>
                    <button className="btn btn-primary me-2" onClick={()=>{window.open(`/fund-history/${client_id}`)}}>Fund History</button>
                    <button className="btn btn-primary me-2" data-bs-toggle="modal" data-bs-target="#add-asset">Asset Management Details</button>
                    <button className="btn btn-primary me-2" data-bs-toggle="modal" data-bs-target="#add-commentary">Add Commentary</button>
                    {
                      ppldata.opDetails[0].pacra_action !== 6 && ppldata.opDetails[0].pacra_action !== 11 && ppldata.opDetails[0].pacra_action !== 18 &&
                      <button type="button" className="btn btn-primary" onClick={()=>{generateReport()}}> <div id="gn">Generate Report</div> <div id="generateprogress" hidden>Please Wait...</div></button> 
                    }
                    
                  </div>
                  : null
                  }
                </>
                : null :
              <>
                {
                  ppldata !== null ? (data.rating_scales_title == "Stability Rating") && 
                  <div>
                    <button className="btn btn-primary me-2" data-bs-toggle="modal" data-bs-target="#excelsheet">Upload Graphs (Excel Sheet)</button>
                    <button className="btn btn-primary me-2" onClick={()=>{window.open(`/fs-facts/${client_id}/${og_rating_id}`)}}>Add Fund Facts</button>
                    <button className="btn btn-primary me-2" onClick={()=>{window.open(`/fund-history/${client_id}`)}}>Fund History</button>
                    <button className="btn btn-primary me-2" data-bs-toggle="modal" data-bs-target="#add-asset">Asset Management Details</button>
                    <button className="btn btn-primary me-2" data-bs-toggle="modal" data-bs-target="#add-commentary">Add Commentary</button>
                    {
                      ppldata.opDetails[0].pacra_action !== 6 && ppldata.opDetails[0].pacra_action !== 11 && ppldata.opDetails[0].pacra_action !== 18 &&
                      <button type="button" className="btn btn-primary" onClick={()=>{generateReport()}}> <div id="gn">Generate Report</div> <div id="generateprogress" hidden>Please Wait...</div></button> 
                    }
                    
                  </div>
                  : null
                  }
              </>
              }
              </>
            : null
          }
          
        </div> :
        <div className="mx-auto"> <CircularProgress /> </div>}
      </div> :
      (reopen == 'Open' && checktask.includes('NL') == false) ?
      <div className="mt-3 fw-4 text-center"> Not allowed to Edit after File Closure</div> :
      <div className="card m-2 shadow p-2">
        {ppldata !== null ? alredyGenenatedRc.length == 0 && <Box className="mx-auto" sx={{ width: "98%" }}>
                    <Collapse in={true}>
                      <Alert
                        severity={'error'}
                        sx={{ mb: 2 }}
                      >
                        {'Please generate RC to enable RR & KRD'}
                      </Alert>
                    </Collapse>
          </Box> : null}
        {ppldata !== null ? ppldata.financialsFile[0].rc_upload_date == null && <Box className="mx-auto" sx={{ width: "98%" }}>
                    <Collapse in={true}>
                      <Alert
                        severity={'error'}
                        sx={{ mb: 2 }}
                      >
                        {'RC approval is required for PPL'}
                      </Alert>
                    </Collapse>
          </Box> : null}
          <Box className="mx-auto mt-1 mb-1" sx={{ width: "98%" }}>
                <Collapse in={alertopen}>
                    <Alert
                        severity={alertType}
                        action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setalertopen(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        sx={{ mb: 2 }}
                      >
                        {AlertMessage}
                    </Alert>
                </Collapse>
          </Box>
        {ppldata !== null ? <div className="d-flex">
          {
            ppldata !== null ?
            ppldata.lastRecord['pacra_outlook'] == ppldata.secondLastRecord['pacra_outlook'] &&
            ppldata.lastRecord['pacra_five_yr'] == ppldata.secondLastRecord['pacra_five_yr'] &&
            ppldata.lastRecord['pacra_lterm'] == ppldata.secondLastRecord['pacra_lterm'] &&
            (ppldata.lastRecord['pacra_sterm'] == ppldata.secondLastRecord['pacra_sterm'] ||
            ppldata.secondLastRecord['pacra_sterm'] == '5') ?
            
            ppldata.secondLastRW !== "unset" && ppldata.lastRecord.review_cancelled != 1 && ppldata.lastRW == ppldata.secondLastRW ?
            <>
              {
                alredyGenenatedRc.length > 1 ? getPpls.length == 2 ?
                <> { (Number(data.rating_update_type) != 6 && Number(data.rating_update_type) != 4) || (ppldata.review == 0) ? <div className="me-1 mb-1" style={{width: "fit-content"}}><button className="btn btn-primary " type="button" onClick={()=>{window.open(`/Ratings/edit_ppl/${client_id}/${og_rating_id}`, '_blank')}}> Post Appeal PPL </button> </div> : null }</> :
                <>{ (Number(data.rating_update_type) != 6 && Number(data.rating_update_type) != 4) || (ppldata.review == 0) ? <div className="me-1 mb-1" style={{width: "fit-content"}}><button className="btn btn-primary " type="button" onClick={()=>{window.open(`/Ratings/closer_internally/${ppldata.lastRecord['client_id']}/${ppldata.lastRecord['id']}`, '_blank')}}> Close Internally </button> </div> : null} </> : null
              }

              {
                alredyGenenatedRc.length <= 1 && <> {(Number(data.rating_update_type) != 6 && Number(data.rating_update_type) != 4) || (ppldata.review == 0) ? <div className="me-1 mb-1" style={{width: "fit-content"}}> <button className="btn btn-primary " type="button" onClick={()=>{window.open(`/Ratings/closer_internally/${ppldata.lastRecord['client_id']}/${ppldata.lastRecord['id']}`, '_blank')}}> Close Internally </button> </div> : null}</>
              }
              {
                ppldata.lastRecord.reviewId=='' || ppldata.lastRecord.reviewId== null ? <> { (Number(data.rating_update_type) != 6 && Number(data.rating_update_type) != 4) || (ppldata.review == 0) ? <div className="me-1 mb-1" style={{width: "fit-content"}}> <button className="btn btn-primary " type="button" onClick={()=>{cancelReview()}}> Dissemination </button> </div> : null}</> : null
              }
            </>
            :
            <>
              {
                alredyGenenatedPpl.length == 0 ?
                ppldata.financialsFile[0].rc_upload_date != null ?
                <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" onClick={()=>{window.open(`/Ratings/generate_ppl/${client_id}/${og_rating_id}`, '_blank')}}> Generate PPL </button> 
                </div> : null : null
              }
              {
                alredyGenenatedPpl.length > 0 ?
                alredyGenenatedPpl[0].second_approve !== 'Approved' ?
                <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" onClick={()=>{window.open(`/Ratings/edit_ppl/${client_id}/${og_rating_id}`, '_blank')}}> Edit PPL </button> 
                </div> : 
                alredyGenenatednl.length == 0 ?
                <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary" type="button" onClick={()=>{window.open(`/Ratings/edit_ppl/${client_id}/${og_rating_id}`, '_blank')}}> PPL </button> 
                </div> :
                <> 
                {
                alredyGenenatednl.length > 0 ?
                alredyGenenatednl[0].second_approve != "Approved" ?
                <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" onClick={()=>{window.open(`/Ratings/edit_ppl/${client_id}/${og_rating_id}`, '_blank')}}> PPL </button> 
                </div> :
                <>
                {
                  pplcount > 1 ?
                  allppl.map((value, index)=>{
                    return(
                      <div className="me-1 mb-1" style={{width: "fit-content"}}>
                      <button className="btn btn-primary " type="button" onClick={()=>{
                        window.open(`/Ratings/pplview/${value.id}`);
                      }} >View PPL ({DateFormat(value.date)})</button>
                     </div>
                    )
                  }) :
                  <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" onClick={()=>{
                    window.open(`/Ratings/pplview/${alredyGenenatedPpl[0].id}`);
                  }} >View PPL</button>
                </div> 
                }
                </> : null
                }
                </> : null
              }
              {/* {
                alredyGenenatedPpl.length > 0 ?
                alredyGenenatedPpl[0].second_approve == 'Approved' && alredyGenenatednl.length == 0 ?
                <>
                {
                  pplcount > 1 ?
                  allppl.map((value, index)=>{
                    return(
                      <div className="me-1 mb-1" style={{width: "fit-content"}}>
                      <button className="btn btn-primary " type="button" onClick={()=>{
                        window.open(`/Ratings/pplview/${value.id}`);
                      }} >View PPL ({DateFormat(value.date)})</button>
                     </div>
                    )
                  }) :
                  <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" onClick={()=>{
                    window.open(`/Ratings/pplview/${alredyGenenatedPpl[0].id}`);
                  }} >View PPL 2</button>
                </div> 
                }
                </>
                : null : null
              } */}

              {
                alredyGenenatednl.length > 0 ?
                alredyGenenatednl[0].second_approve != "Approved" ?
                ppldata.opDetails[0].rating_scale_id == 19 ?
                <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" onClick={()=>{window.open(`/Ratings/bfr/${client_id}/${og_rating_id}`, '_blank')}}> RR & KRD(BFR) </button> 
                </div> :
                ppldata.opDetails[0].rating_scale_id == 28 ?
                <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" onClick={()=>{window.open(`/Ratings/bfr/${client_id}/${og_rating_id}`, '_blank')}}> RR & KRD(SIP) </button> 
                </div> :
                ppldata.opDetails[0].rating_scale_id == 7 ?
                <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" onClick={()=>{window.open(`/Ratings/perf_rank/${client_id}/${og_rating_id}`, '_blank')}}> RR & KRD(Performance Ranking) </button> 
                </div> :
                <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" onClick={()=>{window.open(`/Ratings/rr_krd/${client_id}/${og_rating_id}/add/${ppldata.financialsFile[0].rating_type_id}`, '_blank')}}> RR & KRD </button> 
                  {((isadmin == "true" && data.rating_scales_title == "Entity" && data.model_name.includes("Corporate") && data.segment_id == 2 && (data.ratingUpdateType_title == "Interim" || data.ratingUpdateType_title == "Annual" || data.ratingUpdateType_title == "Surveillance")) || ( data.rating_scales_title == "Entity" && data.model_name.includes("Corporate") && data.segment_id == 2 && (data.ratingUpdateType_title == "Interim" || data.ratingUpdateType_title == "Annual" || data.ratingUpdateType_title == "Surveillance") && data.initiation_date >= "2026-07-01")) ? 
                    <>{(count == 0 || count  == null ) && <button  className="btn btn-primary ms-1" type="button" onClick={()=>{generateRRandKRD()}}>Generate AI RR & KRD <i class="fa fa-magic" style={{fontSize:  20}}></i> </button>}</> : null}
                </div> : null :
                alredyGenenatedRc.length > 0 ?
                ppldata.opDetails[0].rating_scale_id == 19 ?
                <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" onClick={()=>{window.open(`/Ratings/bfr/${client_id}/${og_rating_id}`, '_blank')}}> RR & KRD(BFR) </button> 
                </div> :
                ppldata.opDetails[0].rating_scale_id == 28 ?
                <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" onClick={()=>{window.open(`/Ratings/bfr/${client_id}/${og_rating_id}`, '_blank')}}> RR & KRD(SIP) </button> 
                </div> :
                ppldata.opDetails[0].rating_scale_id== 7 ?
                <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" onClick={()=>{window.open(`/Ratings/perf_rank/${client_id}/${og_rating_id}`, '_blank')}}> RR & KRD(Performance Ranking) </button> 
                </div> :

                // isadmin == "true" ? 
                // <div className="me-1 mb-1" style={{width: "fit-content"}}>
                //   <form className="formclass" action={`${url}/api/generate-ai-rationale/${og_rating_id}`} method="post" target="_blank">
                //       <input type="hidden" name={"id"} value={og_rating_id} />
                //       <button type="submit">Generate AI RR & KRD <i class="fa fa-magic" style={{fontSize:  20}}></i> </button>
                //   </form>
                // </div>:
                <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" onClick={()=>{window.open(`/Ratings/rr_krd/${client_id}/${og_rating_id}/add/${ppldata.financialsFile[0].rating_type_id}`, '_blank')}}> RR & KRD </button> 
                  {((isadmin == "true" && data.rating_scales_title == "Entity" && data.model_name.includes("Corporate") && data.segment_id == 2 && (data.ratingUpdateType_title == "Interim" || data.ratingUpdateType_title == "Annual" || data.ratingUpdateType_title == "Surveillance")) || (data.rating_scales_title == "Entity" && data.model_name.includes("Corporate") && (data.ratingUpdateType_title == "Interim" || data.ratingUpdateType_title == "Annual" || data.ratingUpdateType_title == "Surveillance") &&  data.segment_id == 2 && data.initiation_date >= "2026-07-01")) ? 
                  <>{(count == 0 || count  == null ) && <button  className="btn btn-primary ms-1" type="button" onClick={()=>{generateRRandKRD()}}>Generate AI RR & KRD <i class="fa fa-magic" style={{fontSize:  20}}></i> </button>}</> : null}
                </div> : null

              }

              {
                RRandKrd !== 0 && <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " target="_blank" onClick={()=>{
                    window.open(`${url}/api/draftPr/${og_rating_id}`, '_blank')}
                    }> Draft PR </button> 
                </div>
              }
              {
                alredyGenenatednl.length > 0 ?
                alredyGenenatednl[0].second_approve != "Approved" ? 
                <>
                {ppldata.opDetails[0].rating_scale_id !== 6 && ppldata.opDetails[0].rating_scale_id !== 7 ? <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  {(data.rating_scales_title == "Entity" && data.segment_id == 2 && (data.ratingUpdateType_title == "Interim" || data.ratingUpdateType_title == "Annual" || data.ratingUpdateType_title == "Surveillance") && data.initiation_date >= "2026-07-01" && data.model_name.includes("Corporate")) ? null : <button className="btn btn-primary " type="button" style={{width : "100%"}} data-bs-toggle="modal" data-bs-target="#staticBackdropF">Upload Financials</button>}
                </div> : null}
                {ppldata.opDetails[0].rating_scale_id== 9 ? 
                <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" data-bs-toggle="modal" data-bs-target="#staticBackdropD">Upload Disclosure</button> 
                </div> : null}
                </> : null :
                <>
                {ppldata.opDetails[0].rating_scale_id !== 6 && ppldata.opDetails[0].rating_scale_id !== 7 ? <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  {(data.rating_scales_title == "Entity" && data.segment_id == 2 && (data.ratingUpdateType_title == "Interim" || data.ratingUpdateType_title == "Annual" || data.ratingUpdateType_title == "Surveillance") && data.initiation_date >= "2026-07-01" && data.model_name.includes("Corporate")) ? null : <button className="btn btn-primary " type="button" style={{width : "100%"}} data-bs-toggle="modal" data-bs-target="#staticBackdropF">Upload Financials</button>}
                </div> : null}
                {ppldata.opDetails[0].rating_scale_id== 9 &&
                <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" data-bs-toggle="modal" data-bs-target="#staticBackdropD">Upload Disclosure</button>
                </div>}
                </>
              }
              {
                alredyGenenatednl.length > 0 ? 
                alredyGenenatednl[0].second_approve != "Approved" ?
                <> 
                  { ppldata !== null ?
                    ppldata.opDetails[0].rating_scale_id !== 6 && ppldata.opDetails[0].rating_scale_id !== 7 && ppldata.opDetails[0].pacra_action !== 5
                    && ppldata.opDetails[0].pacra_action !== 6 && ppldata.opDetails[0].pacra_action !== 11 && ppldata.opDetails[0].pacra_action !== 18 &&
                  <div className="me-1 mb-1" style={{width: "fit-content"}}>
                    <button type="button" className="btn btn-primary " onClick={()=>{generateReport()}}> <div id="gn">Generate Report</div> <div id="generateprogress" hidden>Please Wait...</div></button> 
                  </div> : null
                    }
                </>
                 : null :
                 <> 
                  { ppldata !== null ?
                    ppldata.opDetails[0].rating_scale_id !== 6 && ppldata.opDetails[0].rating_scale_id !== 7 && ppldata.opDetails[0].pacra_action !== 5
                    && ppldata.opDetails[0].pacra_action !== 6 && ppldata.opDetails[0].pacra_action !== 11 && ppldata.opDetails[0].pacra_action !== 18 &&
                    <div className="me-1 mb-1" style={{width: "fit-content"}}>
                    <button type="button" className="btn btn-primary " onClick={()=>{generateReport()}}> <div id="gn">Generate Report</div> <div id="generateprogress" hidden>Please Wait...</div></button>
                    </div> : null
                  }
                 </>
              }
            </> 
            :
            <>

              {
                alredyGenenatednl.length > 0 ?
                alredyGenenatednl[0].second_approve != "Approved" ?
                <>
              {
                  ppldata.opDetails[0].rating_scale_id == 19 ?
                  <div className="me-1 mb-1" style={{width: "fit-content"}}>
                    <button className="btn btn-primary " type="button" onClick={()=>{window.open(`/Ratings/bfr/${client_id}/${og_rating_id}`, '_blank')}}> RR & KRD(BFR) </button> 
                  </div> :
                  ppldata.opDetails[0].rating_scale_id == 28 ?
                  <div className="me-1 mb-1" style={{width: "fit-content"}}>
                    <button className="btn btn-primary " type="button" onClick={()=>{window.open(`/Ratings/bfr/${client_id}/${og_rating_id}`, '_blank')}}> RR & KRD(SIP) </button> 
                  </div> :
                ppldata.opDetails[0].rating_scale_id== 7 ?
                <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" onClick={()=>{window.open(`/Ratings/perf_rank/${client_id}/${og_rating_id}`, '_blank')}}> RR & KRD(Performance Ranking) </button>
                </div> :
                // isadmin == "true" ? 
                // <div className="me-1 mb-1" style={{width: "fit-content"}}>
                //   <form className="formclass" action={`${url}/api/generate-ai-rationale/${og_rating_id}`} method="post" target="_blank">
                //       <input type="hidden" name={"id"} value={og_rating_id} />
                //       <button type="submit">Generate AI RR & KRD <i class="fa fa-magic" style={{fontSize:  20}}></i> </button>
                //   </form>
                // </div>:
                <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" onClick={()=>{window.open(`/Ratings/rr_krd/${client_id}/${og_rating_id}/add/${ppldata.financialsFile[0].rating_type_id}`, '_blank')}}> RR & KRD </button>
                  {((isadmin == "true" && data.rating_scales_title == "Entity" && data.model_name.includes("Corporate") && (data.ratingUpdateType_title == "Interim" || data.ratingUpdateType_title == "Annual" || data.ratingUpdateType_title == "Surveillance") && data.segment_id == 2) || (data.rating_scales_title == "Entity" && data.model_name.includes("Corporate") && data.segment_id == 2 && (data.ratingUpdateType_title == "Interim" || data.ratingUpdateType_title == "Annual" || data.ratingUpdateType_title == "Surveillance") && data.initiation_date >= "2026-07-01")) ? 
                  <>{(count == 0 || count  == null ) && <button  className="btn btn-primary ms-1" type="button" onClick={()=>{generateRRandKRD()}}>Generate AI RR & KRD <i class="fa fa-magic" style={{fontSize:  20}}></i> </button>}</> : null}
                </div>
              }

              { ppldata !== null ? ppldata.financialsFile[0].rc_upload_date != null ?
                <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" onClick={()=>{window.open(`/Ratings/edit_ppl/${client_id}/${og_rating_id}`, '_blank')}}> PPL </button> 
                </div> : null : null
              }
                </> : null
                : 
                <>
                  {
                    alredyGenenatedRc.length > 0 ?
                    <>
                    { ppldata !== null ? ppldata.financialsFile[0].rc_upload_date != null ?
                    <div className="me-1 mb-1" style={{width: "fit-content"}}>
                      <button className="btn btn-primary " type="button" style={{width : "100%"}} onClick={()=>{window.open(`/Ratings/edit_ppl/${client_id}/${og_rating_id}`, '_blanl')}}> PPL</button>
                    </div> : null : null
                    }
                      {
                        ppldata.opDetails[0].rating_scale_id == 19 ?
                        <div className="me-1 mb-1" style={{width: "fit-content"}}>
                          <button className="btn btn-primary " type="button" style={{width : "100%"}} onClick={()=>{window.open(`/Ratings/bfr/${client_id}/${og_rating_id}`, '_blank')}}> RR & KRD(BFR) </button>
                        </div>
                         : ppldata.opDetails[0].rating_scale_id== 28 ?
                         <div className="me-1 mb-1" style={{width: "fit-content"}}>
                          <button className="btn btn-primary " type="button" style={{width : "100%"}} onClick={()=>{window.open(`/Ratings/bfr/${client_id}/${og_rating_id}`, '_blank')}}> RR & KRD(SIP) </button>
                        </div>
                         :
                        ppldata.opDetails[0].rating_scale_id== 7 ?
                        <div className="me-1 mb-1" style={{width: "fit-content"}}>
                          <button className="btn btn-primary " type="button" style={{width : "100%"}} onClick={()=>{window.open(`/Ratings/perf_rank/${client_id}/${og_rating_id}`, '_blank')}}> RR & KRD(Performance Ranking) </button>
                        </div>
                         :
                        <div className="me-1 mb-1" style={{width: "fit-content"}}>
                          <button className="btn btn-primary " type="button" style={{width : "100%"}} onClick={()=>{window.open(`/Ratings/rr_krd/${client_id}/${og_rating_id}/add/${ppldata.financialsFile[0].rating_type_id}`, '_blank')}}> RR & KRD </button>
                        </div>
                      }
                    </> : null
                  }
                </>
                
              }
              {
                ppldata !== null ? ppldata.pr !== false ?
                <>
                {RRandKrd !== 0 && 
                  <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" style={{width : "100%"}} onClick={()=>{
                    window.open(`${url}/api/draftPr/${og_rating_id}`, '_blank')}
                    }>Draft PR</button>
                </div>}
                </>
                 :
                <>
                {RRandKrd !== 0 &&
                <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" style={{width : "100%"}} onClick={()=>{
                    window.open(`${url}/api/draftPr/${og_rating_id}`, '_blank')}
                    }>Draft PR</button>
                </div>
                }

                {
                  ppldata.ratingType == 4 ? 
                  <div className="me-1 mb-1" style={{width: "fit-content"}}>
                    <button className="btn btn-primary " style={{width : "100%"}} data-bs-toggle="modal" data-bs-target="#staticBackdropDetail">Add Details</button>
                  </div> : null
                }
                </>
              : null}
              {
                alredyGenenatednl.length > 0 ?
                alredyGenenatednl[0].second_approve == "Approved" ?
                <>
                {
                  pplcount > 1 ?
                  allppl.map((value, index)=>{
                    return(
                      <div className="me-1 mb-1" style={{width: "fit-content"}}>
                      <button className="btn btn-primary " type="button" onClick={()=>{
                        window.open(`/Ratings/pplview/${value.id}`);
                      }} >View PPL ({DateFormat(value.date)})</button>
                     </div>
                    )
                  }) :
                  <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  <button className="btn btn-primary " type="button" onClick={()=>{
                    window.open(`/Ratings/pplview/${alredyGenenatedPpl[0].id}`);
                  }} >View PPL</button>
                </div> 
                }
                </> : null : null
              }
              
              {
                alredyGenenatednl.length > 0 ?
                alredyGenenatednl[0].second_approve != "Approved" ?
                <>
                {ppldata.opDetails[0].rating_scale_id !== 6 && ppldata.opDetails[0].rating_scale_id !== 7 ? <div className="me-1 mb-1" style={{width: "fit-content"}}>
                {(data.rating_scales_title == "Entity" && data.segment_id == 2 && (data.ratingUpdateType_title == "Interim" || data.ratingUpdateType_title == "Annual" || data.ratingUpdateType_title == "Surveillance") && data.initiation_date >= "2026-07-01" && data.model_name.includes("Corporate")) ? null : <button className="btn btn-primary " type="button" style={{width : "100%"}} data-bs-toggle="modal" data-bs-target="#staticBackdropF">Upload Financials</button>}
                </div> : null}
                  {
                    ppldata.opDetails[0].rating_scale_id == 9 ?
                    <div className="me-1 mb-1" style={{width: "fit-content"}}>
                      <button className="btn btn-primary " type="button" style={{width : "100%"}} data-bs-toggle="modal" data-bs-target="#staticBackdropD">Upload Disclosure</button>
                    </div> : null
                  }
                </> : null : 
                <>
                  {ppldata.opDetails[0].rating_scale_id !== 6 && ppldata.opDetails[0].rating_scale_id !== 7 ? <div className="me-1 mb-1" style={{width: "fit-content"}}>
                  {(data.rating_scales_title == "Entity" && data.segment_id == 2 && (data.ratingUpdateType_title == "Interim" || data.ratingUpdateType_title == "Annual" || data.ratingUpdateType_title == "Surveillance") && data.initiation_date >= "2026-07-01" && data.model_name.includes("Corporate")) ? null : <button className="btn btn-primary " type="button" style={{width : "100%"}} data-bs-toggle="modal" data-bs-target="#staticBackdropF">Upload Financials</button>}
                  </div> : null}
                  {
                    ppldata.opDetails[0].rating_scale_id == 9 ?
                    <div className="me-1 mb-1" style={{width: "fit-content"}}>
                      <button className="btn btn-primary " style={{width : "100%"}} data-bs-toggle="modal" data-bs-target="#staticBackdropD">Upload Disclosure</button>
                    </div> : null
                  }

                </>
              }

              {
                alredyGenenatednl.length > 0 ?
                alredyGenenatednl[0].second_approve != "Approved" ?
                <> 
                  {ppldata !== null ?
                    ppldata.opDetails[0].rating_scale_id !== 6 && ppldata.opDetails[0].rating_scale_id !== 7 && ppldata.opDetails[0].pacra_action !== 5
                    && ppldata.opDetails[0].pacra_action !== 6 && ppldata.opDetails[0].pacra_action !== 11 && ppldata.opDetails[0].pacra_action !== 18 &&
                    <div className="me-1 mb-1" style={{width: "fit-content"}}>
                      <button type="button" className="btn btn-primary "  style={{width : "100%"}} onClick={()=>{generateReport()}}> <div id="gn">Generate Report</div> <div id="generateprogress" hidden>Please Wait...</div></button>
                    </div> : null
                  }
                </>
                 : null :
                 <> 
                  { ppldata !== null ?
                    ppldata.opDetails[0].rating_scale_id !== 6 && ppldata.opDetails[0].rating_scale_id !== 7 && ppldata.opDetails[0].pacra_action !== 5
                    && ppldata.opDetails[0].pacra_action !== 6 && ppldata.opDetails[0].pacra_action !== 11 && ppldata.opDetails[0].pacra_action !== 18 &&
                    <div className="me-1 mb-1" style={{width: "fit-content"}}>
                    <button type="button" className="btn btn-primary "  style={{width : "100%"}} onClick={()=>{generateReport()}}> <div id="gn">Generate Report</div> <div id="generateprogress" hidden>Please Wait...</div></button>
                    </div> : null
                  }
                 </>
              }
            </> : null
          }
           {
            ppldata !== null ?
              ppldata.lastRecord['pacra_outlook'] == ppldata.secondLastRecord['pacra_outlook'] &&
              ppldata.lastRecord['pacra_five_yr'] == ppldata.secondLastRecord['pacra_five_yr'] &&
              ppldata.lastRecord['pacra_lterm'] == ppldata.secondLastRecord['pacra_lterm'] &&
              (ppldata.lastRecord['pacra_sterm'] == ppldata.secondLastRecord['pacra_sterm'] ||
              ppldata.secondLastRecord['pacra_sterm'] == '5') ?
              
              ppldata.secondLastRW !== "unset" && ppldata.lastRecord.review_cancelled != 1 && ppldata.lastRW == ppldata.secondLastRW ?
              null :
              <>
              {
              alredyGenenatednl.length > 0 ? 
                  alredyGenenatednl[0].second_approve != "Approved" ?
                <>
                {
                  ppldata !== null ? (data.rating_scales_title == "Stability Rating") && 
                  <div>
                    <button className="btn btn-primary me-2" data-bs-toggle="modal" data-bs-target="#excelsheet">Upload Graphs (Excel Sheet)</button>
                    <button className="btn btn-primary me-2" onClick={()=>{window.open(`/fs-facts/${client_id}/${og_rating_id}`)}}>Add Fund Facts</button>
                    <button className="btn btn-primary me-2" onClick={()=>{window.open(`/fund-history/${client_id}`)}}>Fund History</button>
                    <button className="btn btn-primary me-2" data-bs-toggle="modal" data-bs-target="#add-asset">Asset Management Details</button>
                    <button className="btn btn-primary me-2" data-bs-toggle="modal" data-bs-target="#add-commentary">Add Commentary</button>
                    {
                      ppldata.opDetails[0].pacra_action !== 6 && ppldata.opDetails[0].pacra_action !== 11 && ppldata.opDetails[0].pacra_action !== 18 &&
                      <button type="button" className="btn btn-primary" onClick={()=>{generateReport()}}> <div id="gn">Generate Report</div> <div id="generateprogress" hidden>Please Wait...</div></button> 
                    }
                    
                  </div>
                  : null
                  }
                </>
                : null :
              <>
                {
                  ppldata !== null ? (data.rating_scales_title == "Stability Rating") && 
                  <div>
                    <button className="btn btn-primary me-2" data-bs-toggle="modal" data-bs-target="#excelsheet">Upload Graphs (Excel Sheet)</button>
                    <button className="btn btn-primary me-2" onClick={()=>{window.open(`/fs-facts/${client_id}/${og_rating_id}`)}}>Add Fund Facts</button>
                    <button className="btn btn-primary me-2" onClick={()=>{window.open(`/fund-history/${client_id}`)}}>Fund History</button>
                    <button className="btn btn-primary me-2" data-bs-toggle="modal" data-bs-target="#add-asset">Asset Management Details</button>
                    <button className="btn btn-primary me-2" data-bs-toggle="modal" data-bs-target="#add-commentary">Add Commentary</button>
                    {
                      ppldata.opDetails[0].pacra_action !== 6 && ppldata.opDetails[0].pacra_action !== 11 && ppldata.opDetails[0].pacra_action !== 18 &&
                      <button type="button" className="btn btn-primary" onClick={()=>{generateReport()}}> <div id="gn">Generate Report</div> <div id="generateprogress" hidden>Please Wait...</div></button> 
                    }
                    
                  </div>
                  : null
                  }
              </>
              }
              </>
              :
              <>
              {
              alredyGenenatednl.length > 0 ? 
                  alredyGenenatednl[0].second_approve != "Approved" ?
                <>
                {
                  ppldata !== null ? (data.rating_scales_title == "Stability Rating") && 
                  <div>
                    <button className="btn btn-primary me-2" data-bs-toggle="modal" data-bs-target="#excelsheet">Upload Graphs (Excel Sheet)</button>
                    <button className="btn btn-primary me-2" onClick={()=>{window.open(`/fs-facts/${client_id}/${og_rating_id}`)}}>Add Fund Facts</button>
                    <button className="btn btn-primary me-2" onClick={()=>{window.open(`/fund-history/${client_id}`)}}>Fund History</button>
                    <button className="btn btn-primary me-2" data-bs-toggle="modal" data-bs-target="#add-asset">Asset Management Details</button>
                    <button className="btn btn-primary me-2" data-bs-toggle="modal" data-bs-target="#add-commentary">Add Commentary</button>
                    {
                      ppldata.opDetails[0].pacra_action !== 6 && ppldata.opDetails[0].pacra_action !== 11 && ppldata.opDetails[0].pacra_action !== 18 &&
                      <button type="button" className="btn btn-primary" onClick={()=>{generateReport()}}> <div id="gn">Generate Report</div> <div id="generateprogress" hidden>Please Wait...</div></button> 
                    }
                    
                  </div>
                  : null
                  }
                </>
                : null :
              <>
                {
                  ppldata !== null ? (data.rating_scales_title == "Stability Rating") && 
                  <div>
                    <button className="btn btn-primary me-2" data-bs-toggle="modal" data-bs-target="#excelsheet">Upload Graphs (Excel Sheet)</button>
                    <button className="btn btn-primary me-2" onClick={()=>{window.open(`/fs-facts/${client_id}/${og_rating_id}`)}}>Add Fund Facts</button>
                    <button className="btn btn-primary me-2" onClick={()=>{window.open(`/fund-history/${client_id}`)}}>Fund History</button>
                    <button className="btn btn-primary me-2" data-bs-toggle="modal" data-bs-target="#add-asset">Asset Management Details</button>
                    <button className="btn btn-primary me-2" data-bs-toggle="modal" data-bs-target="#add-commentary">Add Commentary</button>
                    {
                      ppldata.opDetails[0].pacra_action !== 6 && ppldata.opDetails[0].pacra_action !== 11 && ppldata.opDetails[0].pacra_action !== 18 &&
                      <button type="button" className="btn btn-primary" onClick={()=>{generateReport()}}> <div id="gn">Generate Report</div> <div id="generateprogress" hidden>Please Wait...</div></button> 
                    }
                    
                  </div>
                  : null
                  }
              </>
              }
              </>
            : null
          }

        </div> :
        <div className="mx-auto"> <CircularProgress /> </div>}
      </div>
      }

      <div className="modal fade mt-5" id="excelsheet" tabIndex="-1" aria-labelledby="staticBackdrop" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="staticBackdropLabel">Upload Excel Sheet</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
                <Box className="mx-auto mb-1" sx={{ width: "98%" }}>
                    <Collapse in={alertopene}>
                        <Alert
                            severity={alertTypee}
                            action={
                                <IconButton
                                  aria-label="close"
                                  color="inherit"
                                  size="small"
                                  onClick={() => {
                                    setalertOpene(false);
                                  }}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              }
                            sx={{ mb: 2 }}
                          >
                            {AlertMessagee}
                        </Alert>
                    </Collapse>
                </Box>
              <br/>
              <form onSubmit={(event)=>{submitgraph(event)}}>
                <div className='col-10'>
                  <input className='form-control' id='graphfile' type='file' accept=".xls,.xlsx,.xlsm" required />
                </div>
                <div className="mt-3 mx-auto" style={{width: "fit-content"}}>
                  <button type="submit" id="submite" className="btn btn-primary">Submit</button>
                </div>
              </form>
            </div>
          </div>
        </div> 
      </div>
      <div className="modal fade mt-5" id="staticBackdropF" tabIndex="-1" aria-labelledby="staticBackdrop" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="staticBackdropLabel">Upload Financial</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
                <Box className="mx-auto mb-1" sx={{ width: "98%" }}>
                    <Collapse in={alertopen4}>
                        <Alert
                            severity={alertType4}
                            action={
                                <IconButton
                                  aria-label="close"
                                  color="inherit"
                                  size="small"
                                  onClick={() => {
                                    setalertopen4(false);
                                  }}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              }
                            sx={{ mb: 2 }}
                          >
                            {AlertMessage4}
                        </Alert>
                    </Collapse>
                </Box>
              <div>
                {((data.rating_scales_title == "Entity" && data.initiation_date >= "2024-10-28" ) || (data.rating_scales_title == "Debt Instrument" && data.initiation_date >= "2025-06-27") || (data.rating_scales_title == "IFS" && data.initiation_date >= "2025-07-01") || (data.rating_scales_title == "Asset Manager" && data.initiation_date >= "2025-08-06") || (data.rating_scales_title == "Investment Advisor Rating " && data.initiation_date >= "2025-08-06") || (data.rating_scales_title == "Broker Management" && data.initiation_date >= "2025-08-06")) ? "Uploaded File must be in Excel format" : null}
              </div>
              <br/>
              <form onSubmit={uploadfinancials}>
                <div className="col-10 mx-auto">
                  <input className="form-control" type="file" onChange={(e)=>{
                    const file = e.target.files[0];
                    if((data.rating_scales_title == "Entity" && data.initiation_date >= "2024-10-28" ) || (data.rating_scales_title == "Debt Instrument" && data.initiation_date >= "2025-06-27") || (data.rating_scales_title == "IFS" && data.initiation_date >= "2025-07-01") || (data.rating_scales_title == "Asset Manager" && data.initiation_date >= "2025-08-06") || (data.rating_scales_title == "Investment Advisor Rating " && data.initiation_date >= "2025-08-06") || (data.rating_scales_title == "Broker Management" && data.initiation_date >= "2025-08-06")){
                      if (file && (file.type === "application/vnd.ms-excel" || file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")) {
                        setfinancial_file(file);
                      } else {
                        e.target.value = null;
                        setfinancial_file(null);
                        setalertType4("error");
                        setAlertMessage4("Please select file in Excel format.")
                        setalertopen4(true);
                      }
                    }
                    else{
                      if (file && file.type === "application/pdf" && file.size <= 2048 * 1024) {
                        setfinancial_file(file);
                      } else {
                        e.target.value = null;
                        setfinancial_file(null);
                        setalertType4("error");
                        setAlertMessage4("Please select a PDF file with a maximum size of 2 MB.")
                        setalertopen4(true);
                      }
                    }

                  }} required />
                </div>
                <div className="mt-3 mx-auto" style={{width: "fit-content"}}>
                  <button type="submit" className="btn btn-primary">Submit</button>
                </div>
              </form>
            </div>
          </div>
        </div> 
      </div>
      <div className="modal fade mt-5" id="staticBackdropD" tabIndex="-1" aria-labelledby="staticBackdrop" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="staticBackdropLabelD">Upload Disclosure</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
                <Box className="mx-auto mb-1" sx={{ width: "98%" }}>
                    <Collapse in={alertopen5}>
                        <Alert
                            severity={alertType5}
                            action={
                                <IconButton
                                  aria-label="close"
                                  color="inherit"
                                  size="small"
                                  onClick={() => {
                                    setalertopen5(false);
                                  }}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              }
                            sx={{ mb: 2 }}
                          >
                            {AlertMessage5}
                        </Alert>
                    </Collapse>
              </Box>
              <div>
                {((data.rating_scales_title == "Entity" && data.initiation_date >= "2024-10-28" ) || (data.rating_scales_title == "Debt Instrument" && data.initiation_date >= "2025-06-27") || (data.rating_scales_title == "IFS" && data.initiation_date >= "2025-07-01") || (data.rating_scales_title == "Asset Manager" && data.initiation_date >= "2025-08-06") || (data.rating_scales_title == "Investment Advisor Rating " && data.initiation_date >= "2025-08-06") || (data.rating_scales_title == "Broker Management" && data.initiation_date >= "2025-08-06")) ? "Uploaded File must be in Excel format" : null}
              </div>
              <br/>
              <form onSubmit={uploadDisclosure}>
                <div className="col-10 mx-auto">
                  <input className="form-control" type="file" onChange={(e)=>{

                    const file = e.target.files[0];

                    if((data.rating_scales_title == "Entity" && data.initiation_date >= "2024-10-28" ) || (data.rating_scales_title == "Debt Instrument" && data.initiation_date >= "2025-06-27") || (data.rating_scales_title == "IFS" && data.initiation_date >= "2025-07-01") || (data.rating_scales_title == "Asset Manager" && data.initiation_date >= "2025-08-06") || (data.rating_scales_title == "Investment Advisor Rating " && data.initiation_date >= "2025-08-06") || (data.rating_scales_title == "Broker Management" && data.initiation_date >= "2025-08-06")){
                      if (file && (file.type === "application/vnd.ms-excel" || 
                        file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")) {
                        setdisclosure_file(file);
                      } else {
                        e.target.value = null;
                        setdisclosure_file(null);
                        setalertType5("error");
                        setAlertMessage5("Please select file in Excel format.")
                        setalertopen5(true);
                      }
                    }
                    else{
                      if (file && file.type === "application/pdf" && file.size <= 2048 * 1024) {
                        setdisclosure_file(file);
                      } else {
                        e.target.value = null;
                        setdisclosure_file(null);
                        setalertType5("error");
                        setAlertMessage5("Please select a PDF file with a maximum size of 2 MB.")
                        setalertopen5(true);
                      }
                    }
                  }} required />
                </div>
                <div className="mt-3 mx-auto" style={{width: "fit-content"}}>
                  <button type="submit" className="btn btn-primary">Submit</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="modal fade mt-5" id="staticBackdropDetail" tabIndex="-1" aria-labelledby="staticBackdrop" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="staticBackdropLabelD">Enter Details of: {ppldata !== null ? ppldata.opDetails.length > 0 ? ppldata.opDetails[0].name : null : null}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body" style={{height : "420px", overflow: "scroll"}}>
                <Box className="mx-auto mb-1" sx={{ width: "98%" }}>
                    <Collapse in={alertopen3}>
                        <Alert
                            severity={alertType3}
                            action={
                                <IconButton
                                  aria-label="close"
                                  color="inherit"
                                  size="small"
                                  onClick={() => {
                                    setalertopen3(false);
                                  }}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              }
                            sx={{ mb: 2 }}
                          >
                            {AlertMessage3}
                        </Alert>
                    </Collapse>
              </Box>
                <div className="col-10 mx-auto">
                  <div>
                    <label className="fw-bold fs-6">Instrument</label>
                    <div>
                      <select className="form-select" value={instrument} onChange={(e)=>{setinstrument(e.target.value)}}>
                          <option value={'Select Instrument Type'}>Select Instrument Type</option>
                        {instrumenttype.map((value, index)=>{
                          return(
                            <option value={value.id}>{value.title}</option>
                          )
                        })}
                      </select>
                    </div>
                  </div>
                  <div className="mt-1">
                    <label className="fw-bold fs-6">Amount: (mln)</label>
                    <div>
                      <input className="form-control" type="number" value={amount} onChange={(e)=>{setamount(e.target.value)}}></input>
                    </div>
                  </div>
                  <div className="mt-1">
                    <label className="fw-bold fs-6">Issuance Date:</label>
                    <div>
                      <input className="form-control" type="date"
                        onKeyDown={preventKeyboardInput}  // Prevents typing via keyboard
                        onPaste={preventKeyboardInput}    // Prevents pasting into the input                       
                       value={issuance}
                        onChange={(e)=>{setissuance(e.target.value)}}></input>
                    </div>
                  </div>
                  <div className="mt-1">
                    <label className="fw-bold fs-6">Tenor: (years):</label>
                    <div>
                      <input className="form-control" type="number" value={tenor} onChange={(e)=>{settenor(e.target.value)}}></input>
                    </div>
                  </div>
                  <div className="mt-1">
                    <label className="fw-bold fs-6">Redemption Date:</label>
                    <div>
                      <input className="form-control" type="date" value={redemption}
                      onKeyDown={preventKeyboardInput}  // Prevents typing via keyboard
                      onPaste={preventKeyboardInput}    // Prevents pasting into the input                      
                       onChange={(e)=>{setredemption(e.target.value)}}></input>
                    </div>
                  </div>
                </div>
                <div className="mt-3 mx-auto" style={{width: "fit-content"}}>
                  <button type="submit" className="btn btn-primary" onClick={()=>{addDetail()}}>Submit</button>
                </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal fade mt-5" id="add-commentary" tabIndex="-1" aria-labelledby="staticBackdrop" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="staticBackdropLabelD">Add Commentary</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body" style={{height : "420px", overflow: "scroll"}}>
                <Box className="mx-auto mb-1" sx={{ width: "98%" }}>
                    <Collapse in={alertopen6}>
                        <Alert
                            severity={alertType6}
                            action={
                                <IconButton
                                  aria-label="close"
                                  color="inherit"
                                  size="small"
                                  onClick={() => {
                                    setalertopen6(false);
                                  }}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              }
                            sx={{ mb: 2 }}
                          >
                            {AlertMessage6}
                        </Alert>
                    </Collapse>
              </Box>
                <div className="col-10 mx-auto">
                  <div>
                    <textarea className="form-control" value={commentary} onChange={(e)=>{setcommentary(e.target.value)}}></textarea>
                  </div>
                </div>
                <div className="mt-3 mx-auto" style={{width: "fit-content"}}>
                  <button type="submit" className="btn btn-primary" onClick={()=>{AddCommentary()}}>Submit</button>
                </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal fade mt-5" id="add-asset" tabIndex="-1" aria-labelledby="staticBackdrop" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="staticBackdropLabelD">Add Commentary</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body" style={{height : "420px", overflow: "scroll"}}>
                <Box className="mx-auto mb-1" sx={{ width: "98%" }}>
                    <Collapse in={alertopen7}>
                        <Alert
                            severity={alertType7}
                            action={
                                <IconButton
                                  aria-label="close"
                                  color="inherit"
                                  size="small"
                                  onClick={() => {
                                    setalertopen6(false);
                                  }}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              }
                            sx={{ mb: 2 }}
                          >
                            {AlertMessage7}
                        </Alert>
                    </Collapse>
              </Box>
                <div className="col-10 mx-auto">
                  <div className="fw-bold mb-1">
                    Asset Manager
                  </div>
                  <div className="mb-2">
                    <input type="text" className="form-control" value={asset_manager} onChange={(e)=>{setasset_manager(e.target.value)}} />
                  </div>
                  <div className="fw-bold mb-1">
                    Year of Incorporation
                  </div>
                  <div className="mb-2">
                    <input type="number" className="form-control" value={incorporation} onChange={(e)=>{setincorporation(e.target.value)}}  />
                  </div>
                  <div className="fw-bold mb-1">
                    Conventional Funds
                  </div>
                  <div className="mb-2">
                    <input type="number" className="form-control" value={conventional_funds} onChange={(e)=>{setconventional_funds(e.target.value)}}  />
                  </div>
                  <div className="fw-bold mb-1">
                    Shariah-Compliant Funds
                  </div>
                  <div className="mb-2">
                    <input type="number" className="form-control" value={shariah_compliant_funds} onChange={(e)=>{setshariah_compliant_funds(e.target.value)}}  />
                  </div>
                  <div className="fw-bold mb-1">
                    Pension Schemes
                  </div>
                  <div className="mb-2">
                    <input type="number" className="form-control" value={pension_schemes} onChange={(e)=>{setpension_schemes(e.target.value)}}  />
                  </div>
                  <div className="fw-bold mb-1">
                    CEO
                  </div>
                  <div className="mb-2">
                    <input type="text" className="form-control" value={ceo} onChange={(e)=>{setceo(e.target.value)}}  />
                  </div>
                  <div className="fw-bold mb-1">
                    CIO
                  </div>
                  <div className="mb-2">
                    <input type="text" className="form-control" value={cio} onChange={(e)=>{setcio(e.target.value)}}  />
                  </div>
                  <div className="fw-bold mb-1">
                    AUMs
                  </div>
                  <div className="mb-2">
                    <input type="text" className="form-control" value={aums} onChange={(e)=>{setaums(e.target.value)}}  />
                  </div>
                  <div className="fw-bold mb-1">
                    AMC Rating
                  </div>
                  <div className="mb-2">
                    <input type="text" className="form-control" value={aumc_rating} onChange={(e)=>{setaumc_rating(e.target.value)}}  />
                  </div>
                </div>
                <div className="mt-3 mx-auto" style={{width: "fit-content"}}>
                  <button type="submit" className="btn btn-primary" onClick={()=>{AddAssetManager()}}>Submit</button>
                </div>
            </div>
          </div>
        </div>
      </div>
       {/* <div className="modal fade mt-5" id="staticBackdropR" tabIndex="-1" aria-labelledby="staticBackdrop" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered  modal-xl">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="staticBackdropLabel">Add Additional Prompt (Optional)</h5>
                      <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" id="promptclose"></button>
                    </div>
                    <form className="modal-body" onSubmit={(event)=>{generateRRandKRD(event)}}>
                        <div className="col-10 mx-auto">
                          <textarea className="form-control" placeholder="Add Prompt..." value={prompt} style={{height: "190px"}} onChange={(e)=>{setprompt(e.target.value)}}/>
                        </div>
                        <div className="mt-3 mx-auto" style={{width: "fit-content"}}>
                          <button type="submit" className="btn btn-primary">Generate Report</button>
                        </div>
                    </form>
                  </div>
                </div> 
          </div> */}
          {loading && (
        <div className="overlay">
          <div className="loader-box">
            <div className="spinner"></div>
            <p>Please wait...</p>
          </div>
        </div>
      )}
    </div>
  );
}
